import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
};

export type ArticoliImmaginiCollezioniObject = {
  __typename?: 'ArticoliImmaginiCollezioniObject';
  finituraNome?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  imageAlt?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  tonalitaNome?: Maybe<Scalars['String']>;
  tonalitaUrl?: Maybe<Scalars['String']>;
};

export type ArticoliNode = {
  __typename?: 'ArticoliNode';
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  articolicollezioni: Array<CollezioneNode>;
  bcra?: Maybe<Scalars['String']>;
  caratteristichearticoli: Array<CaratteristicheNode>;
  catalogo?: Maybe<Scalars['Boolean']>;
  categoriaDecoro?: Maybe<Scalars['String']>;
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  codice: Scalars['String'];
  codiceCatalogo?: Maybe<Scalars['String']>;
  codiceWeb?: Maybe<Scalars['String']>;
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  dcof?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  description?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionDe?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEn?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionIt?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsFr?: Maybe<Scalars['String']>;
  effettoMatericoId?: Maybe<Scalars['Int']>;
  finituraId?: Maybe<Scalars['Int']>;
  fondo?: Maybe<Scalars['Boolean']>;
  formatiarticoli: Array<FormatiNode>;
  galleryArticle: Array<ImmaginiArticoliNode>;
  id: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  imageAlt?: Maybe<Scalars['String']>;
  immaginicollartMm: Array<ImmaginiCollezioniNode>;
  nome?: Maybe<Scalars['String']>;
  nomeWeb?: Maybe<Scalars['String']>;
  ordinamentoDecoro?: Maybe<Scalars['Int']>;
  pendoloAS4586?: Maybe<Scalars['String']>;
  pendoloBS7976?: Maybe<Scalars['String']>;
  pendoloUNE41901?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  superficiarticoli: Array<SuperficieNode>;
  superficie?: Maybe<SuperficieNode>;
  /** Title of your content */
  title: Scalars['String'];
  /** Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescription?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEn?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionFr?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionIt?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  tonalita?: Maybe<TonalitaNode>;
  /** Make this content visible for this language */
  visible: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleDe: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEn: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleFr: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleIt: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsFr: Scalars['Boolean'];
  xTonalitaCollezioni: Array<TonalitaCollezioneNode>;
};

export type AudioDescrizioneNode = {
  __typename?: 'AudioDescrizioneNode';
  audioFiles?: Maybe<Array<Maybe<AudioFileNode>>>;
  changedDate?: Maybe<Scalars['DateTime']>;
  collezione?: Maybe<CollezioneNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  model?: Maybe<Scalars['Int']>;
  pk?: Maybe<Scalars['Int']>;
  restoreCollezioneSlug?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titolo?: Maybe<Scalars['String']>;
};

export type AudioFileNode = {
  __typename?: 'AudioFileNode';
  audio: AudioDescrizioneNode;
  changedDate?: Maybe<Scalars['DateTime']>;
  creationDate?: Maybe<Scalars['DateTime']>;
  cta?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pk?: Maybe<Scalars['Int']>;
};

export type BrandNode = {
  __typename?: 'BrandNode';
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  adminUrl?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['Int']>;
  breadcrumbs?: Maybe<Array<Maybe<BreadcrumbType>>>;
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  /** Claim */
  claim?: Maybe<Scalars['String']>;
  /** Claim */
  claimDe?: Maybe<Scalars['String']>;
  /** Claim */
  claimEn?: Maybe<Scalars['String']>;
  /** Claim */
  claimEs?: Maybe<Scalars['String']>;
  /** Claim */
  claimFr?: Maybe<Scalars['String']>;
  /** Claim */
  claimIt?: Maybe<Scalars['String']>;
  /** Claim */
  claimUs?: Maybe<Scalars['String']>;
  /** Claim */
  claimUsEs?: Maybe<Scalars['String']>;
  /** Claim */
  claimUsFr?: Maybe<Scalars['String']>;
  /** code */
  codice: Scalars['String'];
  collezioni?: Maybe<Array<Maybe<CollezioneNode>>>;
  correlati?: Maybe<Array<Maybe<BrandNode>>>;
  created?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Main textual description of your content */
  description?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionDe?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEn?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionIt?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsFr?: Maybe<Scalars['String']>;
  descrizione?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitolo?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloDe?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloEn?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloEs?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloFr?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloIt?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloUs?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloUsEs?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloUsFr?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  documentiBrand: Array<DocumentiBrandNode>;
  file?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageAlt?: Maybe<Scalars['String']>;
  immagineHome?: Maybe<Scalars['String']>;
  immagineStatica?: Maybe<Scalars['String']>;
  /** Testo SEO P Listing Collezioni */
  listingTestoSeo?: Maybe<Scalars['String']>;
  /** Testo SEO P Listing Collezioni */
  listingTestoSeoDe?: Maybe<Scalars['String']>;
  /** Testo SEO P Listing Collezioni */
  listingTestoSeoEn?: Maybe<Scalars['String']>;
  /** Testo SEO P Listing Collezioni */
  listingTestoSeoEs?: Maybe<Scalars['String']>;
  /** Testo SEO P Listing Collezioni */
  listingTestoSeoFr?: Maybe<Scalars['String']>;
  /** Testo SEO P Listing Collezioni */
  listingTestoSeoIt?: Maybe<Scalars['String']>;
  /** Testo SEO P Listing Collezioni */
  listingTestoSeoUs?: Maybe<Scalars['String']>;
  /** Testo SEO P Listing Collezioni */
  listingTestoSeoUsEs?: Maybe<Scalars['String']>;
  /** Testo SEO P Listing Collezioni */
  listingTestoSeoUsFr?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 Listing Collezioni */
  listingTitoloSeoH1?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 Listing Collezioni */
  listingTitoloSeoH1De?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 Listing Collezioni */
  listingTitoloSeoH1En?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 Listing Collezioni */
  listingTitoloSeoH1Es?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 Listing Collezioni */
  listingTitoloSeoH1Fr?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 Listing Collezioni */
  listingTitoloSeoH1It?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 Listing Collezioni */
  listingTitoloSeoH1Us?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 Listing Collezioni */
  listingTitoloSeoH1UsEs?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 Listing Collezioni */
  listingTitoloSeoH1UsFr?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 Listing Collezioni */
  listingTitoloSeoH2?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 Listing Collezioni */
  listingTitoloSeoH2De?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 Listing Collezioni */
  listingTitoloSeoH2En?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 Listing Collezioni */
  listingTitoloSeoH2Es?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 Listing Collezioni */
  listingTitoloSeoH2Fr?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 Listing Collezioni */
  listingTitoloSeoH2It?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 Listing Collezioni */
  listingTitoloSeoH2Us?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 Listing Collezioni */
  listingTitoloSeoH2UsEs?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 Listing Collezioni */
  listingTitoloSeoH2UsFr?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  logoTransparent?: Maybe<Scalars['String']>;
  magazinebrands: Array<MagazineNode>;
  magazines?: Maybe<Array<Maybe<MagazineNode>>>;
  mainImage?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modelPk?: Maybe<Scalars['Int']>;
  modified?: Maybe<Scalars['DateTime']>;
  noindex: Scalars['Boolean'];
  /** Nome */
  nome?: Maybe<Scalars['String']>;
  /** Nome */
  nomeDe?: Maybe<Scalars['String']>;
  /** Nome */
  nomeEn?: Maybe<Scalars['String']>;
  /** Nome */
  nomeEs?: Maybe<Scalars['String']>;
  /** Nome */
  nomeFr?: Maybe<Scalars['String']>;
  /** Nome */
  nomeIt?: Maybe<Scalars['String']>;
  /** Nome */
  nomeUs?: Maybe<Scalars['String']>;
  /** Nome */
  nomeUsEs?: Maybe<Scalars['String']>;
  /** Nome */
  nomeUsFr?: Maybe<Scalars['String']>;
  pageActive: Scalars['Boolean'];
  pagebuilders?: Maybe<Array<Maybe<PagebuilderPlaceholderNode>>>;
  pagina?: Maybe<PaginaNode>;
  path?: Maybe<Scalars['String']>;
  /** Payoff */
  payoff?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffDe?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffEn?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffEs?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffFr?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffIt?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffUs?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffUsEs?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffUsFr?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  previewImage?: Maybe<Scalars['String']>;
  progetti?: Maybe<Array<Maybe<ProgettiNode>>>;
  pubblicato?: Maybe<Scalars['Boolean']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitolo?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloDe?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloEn?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloEs?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloFr?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloIt?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloUs?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloUsEs?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloUsFr?: Maybe<Scalars['String']>;
  statoPubblicazione: ProdottiBrandStatoPubblicazioneChoices;
  title?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescription?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEn?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionFr?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionIt?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  titolo: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  visibile?: Maybe<Scalars['Boolean']>;
  visibilitaAl?: Maybe<Scalars['String']>;
  visibilitaDal?: Maybe<Scalars['String']>;
  /** Make this content visible for this language */
  visible: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleDe: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEn: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleFr: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleIt: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsFr: Scalars['Boolean'];
};

export type BreadcrumbType = {
  __typename?: 'BreadcrumbType';
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type CaratteristicheAllCustomObject = {
  __typename?: 'CaratteristicheAllCustomObject';
  children?: Maybe<Array<Maybe<CaratteristicheNode>>>;
  descrizione?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type CaratteristicheNode = {
  __typename?: 'CaratteristicheNode';
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  ambientale?: Maybe<Scalars['Boolean']>;
  caratteristichearticoli: Array<ArticoliNode>;
  caratteristichecollezioni: Array<CollezioneNode>;
  caratteristichepadre?: Maybe<CaratteristichePadreNode>;
  /** code */
  codice: Scalars['String'];
  descrizione?: Maybe<Scalars['String']>;
  descrizioneDe?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneFr?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  descrizioneUs?: Maybe<Scalars['String']>;
  descrizioneUsEs?: Maybe<Scalars['String']>;
  descrizioneUsFr?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  fileDocumentazione?: Maybe<Scalars['String']>;
  /** id */
  id: Scalars['Int'];
  logo?: Maybe<Scalars['String']>;
  /** nome */
  nome: Scalars['String'];
  ordinamento?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  pathDocumentazione?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  titleDe?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  titleEs?: Maybe<Scalars['String']>;
  titleFr?: Maybe<Scalars['String']>;
  titleIt?: Maybe<Scalars['String']>;
  titleUs?: Maybe<Scalars['String']>;
  titleUsEs?: Maybe<Scalars['String']>;
  titleUsFr?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  urlDocumentazione?: Maybe<Scalars['String']>;
};

export type CaratteristichePadreNode = {
  __typename?: 'CaratteristichePadreNode';
  caratteristiche: Array<CaratteristicheNode>;
  children?: Maybe<Array<Maybe<CaratteristicheNode>>>;
  codice?: Maybe<Scalars['String']>;
  descrizione?: Maybe<Scalars['String']>;
  descrizioneDe?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneFr?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  descrizioneUs?: Maybe<Scalars['String']>;
  descrizioneUsEs?: Maybe<Scalars['String']>;
  descrizioneUsFr?: Maybe<Scalars['String']>;
  fileDocumentazione?: Maybe<Scalars['String']>;
  fileIcona?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  pathDocumentazione?: Maybe<Scalars['String']>;
  pathIcona?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleDe?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  titleEs?: Maybe<Scalars['String']>;
  titleFr?: Maybe<Scalars['String']>;
  titleIt?: Maybe<Scalars['String']>;
  titleUs?: Maybe<Scalars['String']>;
  titleUsEs?: Maybe<Scalars['String']>;
  titleUsFr?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  urlDocumentazione?: Maybe<Scalars['String']>;
};

export type CategoriaDecoriObject = {
  __typename?: 'CategoriaDecoriObject';
  categoria?: Maybe<Scalars['String']>;
  decori?: Maybe<Array<Maybe<DecoroObject>>>;
};

export type CategoriaMagazineNode = {
  __typename?: 'CategoriaMagazineNode';
  id: Scalars['ID'];
  magazine: Array<MagazineNode>;
  pk?: Maybe<Scalars['Int']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleDe?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  titleEs?: Maybe<Scalars['String']>;
  titleFr?: Maybe<Scalars['String']>;
  titleIt?: Maybe<Scalars['String']>;
  titleUs?: Maybe<Scalars['String']>;
  titleUsEs?: Maybe<Scalars['String']>;
  titleUsFr?: Maybe<Scalars['String']>;
};

export type CategoriaNode = {
  __typename?: 'CategoriaNode';
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  alt?: Maybe<Scalars['String']>;
  altDe?: Maybe<Scalars['String']>;
  altEn?: Maybe<Scalars['String']>;
  altEs?: Maybe<Scalars['String']>;
  altFr?: Maybe<Scalars['String']>;
  altIt?: Maybe<Scalars['String']>;
  altUs?: Maybe<Scalars['String']>;
  altUsEs?: Maybe<Scalars['String']>;
  altUsFr?: Maybe<Scalars['String']>;
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Main textual description of your content */
  description?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionDe?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEn?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionIt?: Maybe<Scalars['String']>;
  /** Descrizione per categorie di terzo livello */
  descriptionTerzoLivello?: Maybe<Scalars['String']>;
  /** Descrizione per categorie di terzo livello */
  descriptionTerzoLivelloDe?: Maybe<Scalars['String']>;
  /** Descrizione per categorie di terzo livello */
  descriptionTerzoLivelloEn?: Maybe<Scalars['String']>;
  /** Descrizione per categorie di terzo livello */
  descriptionTerzoLivelloEs?: Maybe<Scalars['String']>;
  /** Descrizione per categorie di terzo livello */
  descriptionTerzoLivelloFr?: Maybe<Scalars['String']>;
  /** Descrizione per categorie di terzo livello */
  descriptionTerzoLivelloIt?: Maybe<Scalars['String']>;
  /** Descrizione per categorie di terzo livello */
  descriptionTerzoLivelloUs?: Maybe<Scalars['String']>;
  /** Descrizione per categorie di terzo livello */
  descriptionTerzoLivelloUsEs?: Maybe<Scalars['String']>;
  /** Descrizione per categorie di terzo livello */
  descriptionTerzoLivelloUsFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsFr?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageAlt?: Maybe<Scalars['String']>;
  macrocategoria?: Maybe<MacroCategoriaNode>;
  mainImage?: Maybe<Scalars['String']>;
  modelPk?: Maybe<Scalars['Int']>;
  nome: Scalars['String'];
  nomeTipologieimmaginicollezioni?: Maybe<Scalars['String']>;
  objectId: Scalars['Int'];
  /** ordinamento */
  ordinamento?: Maybe<Scalars['Int']>;
  /** ordinamento */
  ordinamentoSoluzioni?: Maybe<Scalars['Int']>;
  pk?: Maybe<Scalars['Int']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  title: Scalars['String'];
  /** Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescription?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEn?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionFr?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionIt?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Titolo per categorie di terzo livello */
  titleTerzoLivello?: Maybe<Scalars['String']>;
  /** Titolo per categorie di terzo livello */
  titleTerzoLivelloDe?: Maybe<Scalars['String']>;
  /** Titolo per categorie di terzo livello */
  titleTerzoLivelloEn?: Maybe<Scalars['String']>;
  /** Titolo per categorie di terzo livello */
  titleTerzoLivelloEs?: Maybe<Scalars['String']>;
  /** Titolo per categorie di terzo livello */
  titleTerzoLivelloFr?: Maybe<Scalars['String']>;
  /** Titolo per categorie di terzo livello */
  titleTerzoLivelloIt?: Maybe<Scalars['String']>;
  /** Titolo per categorie di terzo livello */
  titleTerzoLivelloUs?: Maybe<Scalars['String']>;
  /** Titolo per categorie di terzo livello */
  titleTerzoLivelloUsEs?: Maybe<Scalars['String']>;
  /** Titolo per categorie di terzo livello */
  titleTerzoLivelloUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  /** Make this content visible for this language */
  visible: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleDe: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEn: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleFr: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleIt: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsFr: Scalars['Boolean'];
  voceMenu: Scalars['String'];
  voceMenuDe?: Maybe<Scalars['String']>;
  voceMenuEn?: Maybe<Scalars['String']>;
  voceMenuEs?: Maybe<Scalars['String']>;
  voceMenuFr?: Maybe<Scalars['String']>;
  voceMenuIt?: Maybe<Scalars['String']>;
  voceMenuUs?: Maybe<Scalars['String']>;
  voceMenuUsEs?: Maybe<Scalars['String']>;
  voceMenuUsFr?: Maybe<Scalars['String']>;
};

export type ClienteNode = {
  __typename?: 'ClienteNode';
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  cap?: Maybe<Scalars['String']>;
  capDummy?: Maybe<Scalars['String']>;
  citta?: Maybe<Scalars['String']>;
  cittaDummy?: Maybe<Scalars['String']>;
  cittaSlug?: Maybe<Scalars['String']>;
  /** code */
  codice: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  /** id */
  id: Scalars['Int'];
  /** indirizzo clienti website marazzi site */
  indirizzo?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  nazione?: Maybe<Scalars['String']>;
  nazioneDummy?: Maybe<Scalars['String']>;
  nazioneSlug?: Maybe<Scalars['String']>;
  /** nome */
  nome: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  noteDe?: Maybe<Scalars['String']>;
  noteEn?: Maybe<Scalars['String']>;
  noteEs?: Maybe<Scalars['String']>;
  noteFr?: Maybe<Scalars['String']>;
  noteIt?: Maybe<Scalars['String']>;
  noteUs?: Maybe<Scalars['String']>;
  noteUsEs?: Maybe<Scalars['String']>;
  noteUsFr?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  /** promozionale_web marazzi site */
  promozionaleWeb: Scalars['Boolean'];
  provincia?: Maybe<Scalars['String']>;
  provinciaDummy?: Maybe<Scalars['String']>;
  provinciaSlug?: Maybe<Scalars['String']>;
  regione?: Maybe<Scalars['String']>;
  regioneDummy?: Maybe<Scalars['String']>;
  regioneSlug?: Maybe<Scalars['String']>;
  /** rivenditore_web marazzi site */
  rivenditoreWeb: Scalars['Boolean'];
  telephone?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type CollezioneNode = {
  __typename?: 'CollezioneNode';
  abaco?: Maybe<ImmaginiCollezioniNode>;
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  alt?: Maybe<Scalars['String']>;
  altDe?: Maybe<Scalars['String']>;
  altEn?: Maybe<Scalars['String']>;
  altEs?: Maybe<Scalars['String']>;
  altFr?: Maybe<Scalars['String']>;
  altIt?: Maybe<Scalars['String']>;
  altUs?: Maybe<Scalars['String']>;
  altUsEs?: Maybe<Scalars['String']>;
  altUsFr?: Maybe<Scalars['String']>;
  articolicollezioni: Array<ArticoliNode>;
  audioItems: Array<AudioDescrizioneNode>;
  brand?: Maybe<BrandNode>;
  breadcrumbs?: Maybe<Array<Maybe<BreadcrumbType>>>;
  caratteristichecollezioni: Array<CaratteristicheNode>;
  cataloghiBrochure?: Maybe<Array<Maybe<DocumentiCollezioniNode>>>;
  catalogo?: Maybe<DocumentiCollezioniNode>;
  categoriaEffetto?: Maybe<CategoriaNode>;
  certificazioni?: Maybe<Array<Maybe<CaratteristicheNode>>>;
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  claim?: Maybe<Scalars['String']>;
  /** Claim */
  claimDe?: Maybe<Scalars['String']>;
  /** Claim */
  claimEn?: Maybe<Scalars['String']>;
  /** Claim */
  claimEs?: Maybe<Scalars['String']>;
  /** Claim */
  claimFr?: Maybe<Scalars['String']>;
  /** Claim */
  claimIt?: Maybe<Scalars['String']>;
  /** Claim */
  claimUs?: Maybe<Scalars['String']>;
  /** Claim */
  claimUsEs?: Maybe<Scalars['String']>;
  /** Claim */
  claimUsFr?: Maybe<Scalars['String']>;
  clickCounter?: Maybe<Scalars['Int']>;
  collezioniCollezioni: Array<CollezioneNode>;
  collezioniSet: Array<CollezioneNode>;
  colori?: Maybe<Array<Maybe<ColoriObject>>>;
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  dataIns?: Maybe<Scalars['Date']>;
  decori?: Maybe<Array<Maybe<CategoriaDecoriObject>>>;
  description?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionDe?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEn?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionIt?: Maybe<Scalars['String']>;
  descriptionSeo?: Maybe<Scalars['String']>;
  descriptionSeoDe?: Maybe<Scalars['String']>;
  descriptionSeoEn?: Maybe<Scalars['String']>;
  descriptionSeoEs?: Maybe<Scalars['String']>;
  descriptionSeoFr?: Maybe<Scalars['String']>;
  descriptionSeoIt?: Maybe<Scalars['String']>;
  descriptionSeoUs?: Maybe<Scalars['String']>;
  descriptionSeoUsEs?: Maybe<Scalars['String']>;
  descriptionSeoUsFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsFr?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitolo?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloDe?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloEn?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloEs?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloFr?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloIt?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloUs?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloUsEs?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloUsFr?: Maybe<Scalars['String']>;
  destinazioni?: Maybe<Array<Maybe<DestinazioneNode>>>;
  docuCollection: Array<DocumentiCollezioniNode>;
  effetto?: Maybe<IspirazioniObject>;
  formatiperpose: Array<FormatiNode>;
  gallery?: Maybe<Array<Maybe<ImmaginiCollezioniNode>>>;
  galleryCollection: Array<ImmaginiCollezioniNode>;
  id: Scalars['Int'];
  imageCopertina?: Maybe<Scalars['String']>;
  immagineVideo?: Maybe<ImmaginiCollezioniNode>;
  inevidenza?: Maybe<Scalars['Boolean']>;
  inevidenzaOrdinamento?: Maybe<Scalars['Int']>;
  infoProgetti: Array<InfoProgettoNode>;
  isUsa?: Maybe<Scalars['Boolean']>;
  ispirazioniCollezioni: Array<IspirazioniNode>;
  lappato?: Maybe<Scalars['Boolean']>;
  lappatoUrl?: Maybe<Scalars['String']>;
  linkVideo?: Maybe<Scalars['String']>;
  linkVideoDe?: Maybe<Scalars['String']>;
  linkVideoEn?: Maybe<Scalars['String']>;
  linkVideoEs?: Maybe<Scalars['String']>;
  linkVideoFr?: Maybe<Scalars['String']>;
  linkVideoIt?: Maybe<Scalars['String']>;
  linkVideoUs?: Maybe<Scalars['String']>;
  linkVideoUsEs?: Maybe<Scalars['String']>;
  linkVideoUsFr?: Maybe<Scalars['String']>;
  listingImage?: Maybe<ImmaginiCollezioniNode>;
  logo?: Maybe<Scalars['String']>;
  magazinecollezioni: Array<MagazineNode>;
  magazines?: Maybe<Array<Maybe<MagazineNode>>>;
  modelPk?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  /** Nome */
  nomeDe?: Maybe<Scalars['String']>;
  /** Nome */
  nomeEn?: Maybe<Scalars['String']>;
  /** Nome */
  nomeEs?: Maybe<Scalars['String']>;
  /** Nome */
  nomeFr?: Maybe<Scalars['String']>;
  /** Nome */
  nomeIt?: Maybe<Scalars['String']>;
  /** Nome */
  nomeUs?: Maybe<Scalars['String']>;
  /** Nome */
  nomeUsEs?: Maybe<Scalars['String']>;
  /** Nome */
  nomeUsFr?: Maybe<Scalars['String']>;
  novita?: Maybe<Scalars['Boolean']>;
  /** Make this new content visible for this language */
  novitaDe?: Maybe<Scalars['Boolean']>;
  /** Make this new content visible for this language */
  novitaEn?: Maybe<Scalars['Boolean']>;
  /** Make this new content visible for this language */
  novitaEs?: Maybe<Scalars['Boolean']>;
  /** Make this new content visible for this language */
  novitaFr?: Maybe<Scalars['Boolean']>;
  /** Make this new content visible for this language */
  novitaIt?: Maybe<Scalars['Boolean']>;
  /** Make this new content visible for this language */
  novitaUs?: Maybe<Scalars['Boolean']>;
  /** Make this new content visible for this language */
  novitaUsEs?: Maybe<Scalars['Boolean']>;
  /** Make this new content visible for this language */
  novitaUsFr?: Maybe<Scalars['Boolean']>;
  nsf?: Maybe<Scalars['Boolean']>;
  nsfDe?: Maybe<Scalars['Boolean']>;
  nsfEn?: Maybe<Scalars['Boolean']>;
  nsfEs?: Maybe<Scalars['Boolean']>;
  nsfFr?: Maybe<Scalars['Boolean']>;
  nsfIt?: Maybe<Scalars['Boolean']>;
  nsfMagazineSlug?: Maybe<Scalars['String']>;
  nsfTesto?: Maybe<Scalars['String']>;
  nsfTestoDe?: Maybe<Scalars['String']>;
  nsfTestoEn?: Maybe<Scalars['String']>;
  nsfTestoEs?: Maybe<Scalars['String']>;
  nsfTestoFr?: Maybe<Scalars['String']>;
  nsfTestoIt?: Maybe<Scalars['String']>;
  nsfTestoUs?: Maybe<Scalars['String']>;
  nsfTestoUsEs?: Maybe<Scalars['String']>;
  nsfTestoUsFr?: Maybe<Scalars['String']>;
  nsfUs?: Maybe<Scalars['Boolean']>;
  nsfUsEs?: Maybe<Scalars['Boolean']>;
  nsfUsFr?: Maybe<Scalars['Boolean']>;
  opuses?: Maybe<Array<Maybe<OpusNode>>>;
  ordinamento?: Maybe<Scalars['Int']>;
  payoff?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffDe?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffEn?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffEs?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffFr?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffIt?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffUs?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffUsEs?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffUsFr?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  prefissoTonalita?: Maybe<Scalars['String']>;
  progetti?: Maybe<Array<Maybe<ProgettiNode>>>;
  progettiCollezioni: Array<ProgettiNode>;
  quickship?: Maybe<Scalars['Boolean']>;
  quickshipDe?: Maybe<Scalars['Boolean']>;
  quickshipEn?: Maybe<Scalars['Boolean']>;
  quickshipEs?: Maybe<Scalars['Boolean']>;
  quickshipFr?: Maybe<Scalars['Boolean']>;
  quickshipIt?: Maybe<Scalars['Boolean']>;
  quickshipUs?: Maybe<Scalars['Boolean']>;
  quickshipUsEs?: Maybe<Scalars['Boolean']>;
  quickshipUsFr?: Maybe<Scalars['Boolean']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  shadeVariations?: Maybe<Array<Maybe<ShadeVariationNode>>>;
  shield?: Maybe<Scalars['Boolean']>;
  shieldDe?: Maybe<Scalars['Boolean']>;
  shieldEn?: Maybe<Scalars['Boolean']>;
  shieldEs?: Maybe<Scalars['Boolean']>;
  shieldFormatiSuperfici?: Maybe<Scalars['String']>;
  shieldFormatiSuperficiDe?: Maybe<Scalars['String']>;
  shieldFormatiSuperficiEn?: Maybe<Scalars['String']>;
  shieldFormatiSuperficiEs?: Maybe<Scalars['String']>;
  shieldFormatiSuperficiFr?: Maybe<Scalars['String']>;
  shieldFormatiSuperficiIt?: Maybe<Scalars['String']>;
  shieldFormatiSuperficiUs?: Maybe<Scalars['String']>;
  shieldFormatiSuperficiUsEs?: Maybe<Scalars['String']>;
  shieldFormatiSuperficiUsFr?: Maybe<Scalars['String']>;
  shieldFr?: Maybe<Scalars['Boolean']>;
  shieldIt?: Maybe<Scalars['Boolean']>;
  shieldUs?: Maybe<Scalars['Boolean']>;
  shieldUsEs?: Maybe<Scalars['Boolean']>;
  shieldUsFr?: Maybe<Scalars['Boolean']>;
  silktech?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitolo?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloDe?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloEn?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloEs?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloFr?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloIt?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloUs?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloUsEs?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloUsFr?: Maybe<Scalars['String']>;
  spessoriFormati?: Maybe<Array<Maybe<SpessoriFormatiObject>>>;
  subtitleH1?: Maybe<Scalars['String']>;
  subtitleH1De?: Maybe<Scalars['String']>;
  subtitleH1En?: Maybe<Scalars['String']>;
  subtitleH1Es?: Maybe<Scalars['String']>;
  subtitleH1Fr?: Maybe<Scalars['String']>;
  subtitleH1It?: Maybe<Scalars['String']>;
  subtitleH1Us?: Maybe<Scalars['String']>;
  subtitleH1UsEs?: Maybe<Scalars['String']>;
  subtitleH1UsFr?: Maybe<Scalars['String']>;
  superfici?: Maybe<Array<Maybe<SuperficiObject>>>;
  /** Title of your content */
  title: Scalars['String'];
  /** Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescription?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEn?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionFr?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionIt?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  titleH1?: Maybe<Scalars['String']>;
  titleH1De?: Maybe<Scalars['String']>;
  titleH1En?: Maybe<Scalars['String']>;
  titleH1Es?: Maybe<Scalars['String']>;
  titleH1Fr?: Maybe<Scalars['String']>;
  titleH1It?: Maybe<Scalars['String']>;
  titleH1Us?: Maybe<Scalars['String']>;
  titleH1UsEs?: Maybe<Scalars['String']>;
  titleH1UsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  tonalitacollezioni: Array<TonalitaNode>;
  url?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
  /** Make this content visible for this language */
  visible: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleDe: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEn: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleFr: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleIt: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsFr: Scalars['Boolean'];
  xTonalitaCollezioni: Array<TonalitaCollezioneNode>;
};

export type ColoriObject = {
  __typename?: 'ColoriObject';
  id?: Maybe<Scalars['Int']>;
  nome?: Maybe<Scalars['String']>;
  tonalita?: Maybe<Array<Maybe<TonalitaColoriObject>>>;
};

export type ContattoRivenditoreInput = {
  address?: InputMaybe<Scalars['String']>;
  captcha: Scalars['String'];
  categoria?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cliente?: InputMaybe<Scalars['Int']>;
  cognome?: InputMaybe<Scalars['String']>;
  collezione?: InputMaybe<Scalars['String']>;
  countrycontact?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  nome?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  privacyOpt: Scalars['Boolean'];
  privacyOptSecond?: InputMaybe<Scalars['Boolean']>;
  profession?: InputMaybe<Scalars['String']>;
  provcontact?: InputMaybe<Scalars['String']>;
  ragiosoc?: InputMaybe<Scalars['String']>;
  telefono?: InputMaybe<Scalars['String']>;
  tipo?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type CreateContattoRivenditore = {
  __typename?: 'CreateContattoRivenditore';
  status?: Maybe<Scalars['Boolean']>;
};

export type DecoroObject = {
  __typename?: 'DecoroObject';
  categoriaDecoro?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<ImmaginiArticoliNode>;
  nomeWeb?: Maybe<Scalars['String']>;
  styleHeight?: Maybe<Scalars['Int']>;
  styleWidth?: Maybe<Scalars['Int']>;
};

export type DestinazioneNode = {
  __typename?: 'DestinazioneNode';
  active?: Maybe<Scalars['Boolean']>;
  file?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageAlt?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  titolo?: Maybe<Scalars['String']>;
  titoloDe?: Maybe<Scalars['String']>;
  titoloEn?: Maybe<Scalars['String']>;
  titoloEs?: Maybe<Scalars['String']>;
  titoloFr?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
  titoloUs?: Maybe<Scalars['String']>;
  titoloUsEs?: Maybe<Scalars['String']>;
  titoloUsFr?: Maybe<Scalars['String']>;
};

export type DestinazioneSoluzioneNode = {
  __typename?: 'DestinazioneSoluzioneNode';
  alt?: Maybe<Scalars['String']>;
  altDe?: Maybe<Scalars['String']>;
  altEn?: Maybe<Scalars['String']>;
  altEs?: Maybe<Scalars['String']>;
  altFr?: Maybe<Scalars['String']>;
  altIt?: Maybe<Scalars['String']>;
  altUs?: Maybe<Scalars['String']>;
  altUsEs?: Maybe<Scalars['String']>;
  altUsFr?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imageAlt?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  soluzioni: Array<SoluzioneNode>;
  title?: Maybe<Scalars['String']>;
  titleDe?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  titleEs?: Maybe<Scalars['String']>;
  titleFr?: Maybe<Scalars['String']>;
  titleIt?: Maybe<Scalars['String']>;
  titleUs?: Maybe<Scalars['String']>;
  titleUsEs?: Maybe<Scalars['String']>;
  titleUsFr?: Maybe<Scalars['String']>;
};

export type DestinazioneUsoNode = {
  __typename?: 'DestinazioneUsoNode';
  active?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  progetti: Array<ProgettiNode>;
  slug?: Maybe<Scalars['String']>;
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  titolo?: Maybe<Scalars['String']>;
  titoloDe?: Maybe<Scalars['String']>;
  titoloEn?: Maybe<Scalars['String']>;
  titoloEs?: Maybe<Scalars['String']>;
  titoloFr?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
  titoloUs?: Maybe<Scalars['String']>;
  titoloUsEs?: Maybe<Scalars['String']>;
  titoloUsFr?: Maybe<Scalars['String']>;
};

export type DocumentiBrandNode = {
  __typename?: 'DocumentiBrandNode';
  active?: Maybe<Scalars['Boolean']>;
  brand?: Maybe<BrandNode>;
  dataIns?: Maybe<Scalars['DateTime']>;
  dataUltMod?: Maybe<Scalars['DateTime']>;
  file?: Maybe<Scalars['String']>;
  fileHead?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lingua?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  tipologie?: Maybe<TipologieNode>;
  url?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type DocumentiCollezioniNode = {
  __typename?: 'DocumentiCollezioniNode';
  active?: Maybe<Scalars['Boolean']>;
  brand?: Maybe<BrandNode>;
  countdown?: Maybe<Scalars['Int']>;
  docuCollection?: Maybe<CollezioneNode>;
  file: Scalars['String'];
  id: Scalars['Int'];
  nomeWeb?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  tipologiedocumenti?: Maybe<TipologieNode>;
  titledocu?: Maybe<Scalars['String']>;
  titledocuDe?: Maybe<Scalars['String']>;
  titledocuEn?: Maybe<Scalars['String']>;
  titledocuEs?: Maybe<Scalars['String']>;
  titledocuFr?: Maybe<Scalars['String']>;
  titledocuIt?: Maybe<Scalars['String']>;
  titledocuUs?: Maybe<Scalars['String']>;
  titledocuUsEs?: Maybe<Scalars['String']>;
  titledocuUsFr?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type FormatiNode = {
  __typename?: 'FormatiNode';
  active?: Maybe<Scalars['Boolean']>;
  formatiarticoli: Array<ArticoliNode>;
  formatiperpose: Array<CollezioneNode>;
  formatoOpuscode: Array<OpusCodeNode>;
  id?: Maybe<Scalars['Int']>;
  infoProgetti: Array<InfoProgettoNode>;
  lato1Cm?: Maybe<Scalars['String']>;
  lato1Denominatore?: Maybe<Scalars['String']>;
  lato1Intero?: Maybe<Scalars['String']>;
  lato1Numeratore?: Maybe<Scalars['String']>;
  lato1PxWeb?: Maybe<Scalars['String']>;
  lato2Cm?: Maybe<Scalars['String']>;
  lato2Denominatore?: Maybe<Scalars['String']>;
  lato2Intero?: Maybe<Scalars['String']>;
  lato2Numeratore?: Maybe<Scalars['String']>;
  lato2PxWeb?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  rangeWeb?: Maybe<Scalars['Int']>;
};

export type FormatiSpessoriObject = {
  __typename?: 'FormatiSpessoriObject';
  lato1Denominatore?: Maybe<Scalars['String']>;
  lato1Intero?: Maybe<Scalars['String']>;
  lato1Numeratore?: Maybe<Scalars['String']>;
  lato2Denominatore?: Maybe<Scalars['String']>;
  lato2Intero?: Maybe<Scalars['String']>;
  lato2Numeratore?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  spessoriarticoliCodice?: Maybe<Scalars['String']>;
};

export type GalleryItemNode = {
  __typename?: 'GalleryItemNode';
  filePath?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageAlt?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  news: MagazineNode;
  order: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  titleDe?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  titleEs?: Maybe<Scalars['String']>;
  titleFr?: Maybe<Scalars['String']>;
  titleIt?: Maybe<Scalars['String']>;
  titleUs?: Maybe<Scalars['String']>;
  titleUsEs?: Maybe<Scalars['String']>;
  titleUsFr?: Maybe<Scalars['String']>;
};

export type HrefLangType = {
  __typename?: 'HrefLangType';
  href?: Maybe<Scalars['String']>;
  hrefLang?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type ImmaginiArticoliNode = {
  __typename?: 'ImmaginiArticoliNode';
  active?: Maybe<Scalars['Boolean']>;
  cropDisabled: Scalars['Boolean'];
  dataUltMod?: Maybe<Scalars['DateTime']>;
  file: Scalars['String'];
  galleryArticle?: Maybe<ArticoliNode>;
  id?: Maybe<Scalars['Int']>;
  ordinamentoWeb?: Maybe<Scalars['Int']>;
  path: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  visualizzaWeb?: Maybe<Scalars['Boolean']>;
  visualizzazioniId: Scalars['Int'];
};

export type ImmaginiCollezioniNode = {
  __typename?: 'ImmaginiCollezioniNode';
  active?: Maybe<Scalars['Boolean']>;
  altTag?: Maybe<Scalars['String']>;
  altTagDe?: Maybe<Scalars['String']>;
  altTagEn?: Maybe<Scalars['String']>;
  altTagEs?: Maybe<Scalars['String']>;
  altTagFr?: Maybe<Scalars['String']>;
  altTagIt?: Maybe<Scalars['String']>;
  altTagUs?: Maybe<Scalars['String']>;
  altTagUsEs?: Maybe<Scalars['String']>;
  altTagUsFr?: Maybe<Scalars['String']>;
  articoli: Array<ArticoliNode>;
  articoliGallery?: Maybe<Array<Maybe<ArticoliImmaginiCollezioniObject>>>;
  dataUltMod?: Maybe<Scalars['DateTime']>;
  file: Scalars['String'];
  galleryCollection?: Maybe<CollezioneNode>;
  galleryIspirazioni?: Maybe<IspirazioniNode>;
  id?: Maybe<Scalars['Int']>;
  imageAlt?: Maybe<Scalars['String']>;
  imageDescriptionElaborata?: Maybe<Scalars['String']>;
  imageDescriptionElaborataDe?: Maybe<Scalars['String']>;
  imageDescriptionElaborataEn?: Maybe<Scalars['String']>;
  imageDescriptionElaborataEs?: Maybe<Scalars['String']>;
  imageDescriptionElaborataFr?: Maybe<Scalars['String']>;
  imageDescriptionElaborataIt?: Maybe<Scalars['String']>;
  imageDescriptionElaborataUs?: Maybe<Scalars['String']>;
  imageDescriptionElaborataUsEs?: Maybe<Scalars['String']>;
  imageDescriptionElaborataUsFr?: Maybe<Scalars['String']>;
  ordinamentoWeb?: Maybe<Scalars['Int']>;
  ordinamentoWebAmbienti?: Maybe<Scalars['Int']>;
  ordinamentoWebColori?: Maybe<Scalars['Int']>;
  ordinamentoWebIspirazioni?: Maybe<Scalars['Int']>;
  ordinamentoWebMacroformati?: Maybe<Scalars['Int']>;
  ordinamentoWebPose?: Maybe<Scalars['Int']>;
  path: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  visualizzaWeb?: Maybe<Scalars['Boolean']>;
  visualizzaWebAmbienti?: Maybe<Scalars['Boolean']>;
  visualizzaWebColori?: Maybe<Scalars['Boolean']>;
  visualizzaWebIspirazioni?: Maybe<Scalars['Boolean']>;
  visualizzaWebMacroformati?: Maybe<Scalars['Boolean']>;
  visualizzaWebPose?: Maybe<Scalars['Boolean']>;
  visualizzazioniId: Scalars['Int'];
};

export type ImmaginiProgettiNode = {
  __typename?: 'ImmaginiProgettiNode';
  /** Make this content visible according to Site and Language visibility */
  active?: Maybe<Scalars['Boolean']>;
  /** alt_tag file website marazzi site */
  altTag?: Maybe<Scalars['String']>;
  /** alt_tag file website marazzi site */
  altTagDe?: Maybe<Scalars['String']>;
  /** alt_tag file website marazzi site */
  altTagEn?: Maybe<Scalars['String']>;
  /** alt_tag file website marazzi site */
  altTagEs?: Maybe<Scalars['String']>;
  /** alt_tag file website marazzi site */
  altTagFr?: Maybe<Scalars['String']>;
  /** alt_tag file website marazzi site */
  altTagIt?: Maybe<Scalars['String']>;
  /** alt_tag file website marazzi site */
  altTagUs?: Maybe<Scalars['String']>;
  /** alt_tag file website marazzi site */
  altTagUsEs?: Maybe<Scalars['String']>;
  /** alt_tag file website marazzi site */
  altTagUsFr?: Maybe<Scalars['String']>;
  dataUltMod?: Maybe<Scalars['DateTime']>;
  /** filename website marazzi site */
  file?: Maybe<Scalars['String']>;
  galleryProgetti?: Maybe<ProgettiNode>;
  id?: Maybe<Scalars['Int']>;
  imageAlt?: Maybe<Scalars['String']>;
  /** ordinamento_web marazzi site */
  ordinamentoWeb: Scalars['Int'];
  /** path file website marazzi site */
  path?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  /** visualizza_web marazzi site */
  visualizzaWeb?: Maybe<Scalars['Boolean']>;
  /** tipo visualizzazione id website marazzi site */
  visualizzazioniId: Scalars['Int'];
};

export type InfoProgettoCollezioneObject = {
  __typename?: 'InfoProgettoCollezioneObject';
  collezione?: Maybe<CollezioneNode>;
  infoProgetti?: Maybe<Array<Maybe<InfoProgettoNode>>>;
};

export type InfoProgettoNode = {
  __typename?: 'InfoProgettoNode';
  collezione?: Maybe<CollezioneNode>;
  coloreNome?: Maybe<Scalars['String']>;
  finituraNome?: Maybe<Scalars['String']>;
  formato?: Maybe<FormatiNode>;
  id: Scalars['Int'];
  progetto?: Maybe<ProgettiNode>;
  spessore?: Maybe<Scalars['String']>;
  superficie?: Maybe<SuperficiObject>;
  tonalita?: Maybe<TonalitaNode>;
  tonalitaUrl?: Maybe<Scalars['String']>;
};

export type IspirazioniNode = {
  __typename?: 'IspirazioniNode';
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Main textual description of your content */
  description?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionDe?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEn?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionIt?: Maybe<Scalars['String']>;
  descriptionSeo?: Maybe<Scalars['String']>;
  descriptionSeoDe?: Maybe<Scalars['String']>;
  descriptionSeoEn?: Maybe<Scalars['String']>;
  descriptionSeoEs?: Maybe<Scalars['String']>;
  descriptionSeoFr?: Maybe<Scalars['String']>;
  descriptionSeoIt?: Maybe<Scalars['String']>;
  descriptionSeoUs?: Maybe<Scalars['String']>;
  descriptionSeoUsEs?: Maybe<Scalars['String']>;
  descriptionSeoUsFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsFr?: Maybe<Scalars['String']>;
  galleryIspirazioni: Array<ImmaginiCollezioniNode>;
  id: Scalars['Int'];
  imageAlt?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  ispirazioniCollezioni: Array<CollezioneNode>;
  name: Scalars['String'];
  progressivo: Scalars['Int'];
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitolo?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloDe?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloEn?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloEs?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloFr?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloIt?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloUs?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloUsEs?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloUsFr?: Maybe<Scalars['String']>;
  /** Testo SEO P */
  testoSeo?: Maybe<Scalars['String']>;
  /** Testo SEO P */
  testoSeoDe?: Maybe<Scalars['String']>;
  /** Testo SEO P */
  testoSeoEn?: Maybe<Scalars['String']>;
  /** Testo SEO P */
  testoSeoEs?: Maybe<Scalars['String']>;
  /** Testo SEO P */
  testoSeoFr?: Maybe<Scalars['String']>;
  /** Testo SEO P */
  testoSeoIt?: Maybe<Scalars['String']>;
  /** Testo SEO P */
  testoSeoUs?: Maybe<Scalars['String']>;
  /** Testo SEO P */
  testoSeoUsEs?: Maybe<Scalars['String']>;
  /** Testo SEO P */
  testoSeoUsFr?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescription?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEn?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionFr?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionIt?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 */
  titoloSeoH1?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 */
  titoloSeoH1De?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 */
  titoloSeoH1En?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 */
  titoloSeoH1Es?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 */
  titoloSeoH1Fr?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 */
  titoloSeoH1It?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 */
  titoloSeoH1Us?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 */
  titoloSeoH1UsEs?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 */
  titoloSeoH1UsFr?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 */
  titoloSeoH2?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 */
  titoloSeoH2De?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 */
  titoloSeoH2En?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 */
  titoloSeoH2Es?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 */
  titoloSeoH2Fr?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 */
  titoloSeoH2It?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 */
  titoloSeoH2Us?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 */
  titoloSeoH2UsEs?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 */
  titoloSeoH2UsFr?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  /** Make this content visible for this language */
  visible: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleDe: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEn: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleFr: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleIt: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsFr: Scalars['Boolean'];
};

export type IspirazioniObject = {
  __typename?: 'IspirazioniObject';
  imageUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type LocalitaNode = {
  __typename?: 'LocalitaNode';
  clienteRef?: Maybe<ClienteNode>;
  name?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  tipo?: Maybe<Scalars['String']>;
};

export type MacroCategoriaNode = {
  __typename?: 'MacroCategoriaNode';
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  alt?: Maybe<Scalars['String']>;
  altDe?: Maybe<Scalars['String']>;
  altEn?: Maybe<Scalars['String']>;
  altEs?: Maybe<Scalars['String']>;
  altFr?: Maybe<Scalars['String']>;
  altIt?: Maybe<Scalars['String']>;
  altUs?: Maybe<Scalars['String']>;
  altUsEs?: Maybe<Scalars['String']>;
  altUsFr?: Maybe<Scalars['String']>;
  categorie?: Maybe<Array<Maybe<CategoriaNode>>>;
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  chiaveRicerca: Scalars['String'];
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Main textual description of your content */
  description?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionDe?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEn?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionIt?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsFr?: Maybe<Scalars['String']>;
  descrizione?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageAlt?: Maybe<Scalars['String']>;
  intestazioneListing: Scalars['String'];
  intestazioneListingDe?: Maybe<Scalars['String']>;
  intestazioneListingEn?: Maybe<Scalars['String']>;
  intestazioneListingEs?: Maybe<Scalars['String']>;
  intestazioneListingFr?: Maybe<Scalars['String']>;
  intestazioneListingIt?: Maybe<Scalars['String']>;
  intestazioneListingUs?: Maybe<Scalars['String']>;
  intestazioneListingUsEs?: Maybe<Scalars['String']>;
  intestazioneListingUsFr?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Scalars['String']>;
  nome: Scalars['String'];
  nomeDe?: Maybe<Scalars['String']>;
  nomeEn?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeFr?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  nomeUs?: Maybe<Scalars['String']>;
  nomeUsEs?: Maybe<Scalars['String']>;
  nomeUsFr?: Maybe<Scalars['String']>;
  /** ordinamento */
  ordinamento?: Maybe<Scalars['Int']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  soluzioniMacroCategorie: Array<SoluzioneNode>;
  /** Title of your content */
  title: Scalars['String'];
  /** Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescription?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEn?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionFr?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionIt?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible for this language */
  visible: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleDe: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEn: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleFr: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleIt: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsFr: Scalars['Boolean'];
};

export type MagazineNode = {
  __typename?: 'MagazineNode';
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  abstractTitle?: Maybe<Scalars['String']>;
  abstractTitleDe?: Maybe<Scalars['String']>;
  abstractTitleEn?: Maybe<Scalars['String']>;
  abstractTitleEs?: Maybe<Scalars['String']>;
  abstractTitleFr?: Maybe<Scalars['String']>;
  abstractTitleIt?: Maybe<Scalars['String']>;
  abstractTitleUs?: Maybe<Scalars['String']>;
  abstractTitleUsEs?: Maybe<Scalars['String']>;
  abstractTitleUsFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  adminUrl?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  altDe?: Maybe<Scalars['String']>;
  altEn?: Maybe<Scalars['String']>;
  altEs?: Maybe<Scalars['String']>;
  altFr?: Maybe<Scalars['String']>;
  altIt?: Maybe<Scalars['String']>;
  altUs?: Maybe<Scalars['String']>;
  altUsEs?: Maybe<Scalars['String']>;
  altUsFr?: Maybe<Scalars['String']>;
  categoria?: Maybe<CategoriaMagazineNode>;
  categoriaTitle?: Maybe<Scalars['String']>;
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  correlati?: Maybe<Array<Maybe<MagazineNode>>>;
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  /** Parte testuale inferiore */
  descriptionFooter?: Maybe<Scalars['String']>;
  /** Parte testuale inferiore */
  descriptionFooterDe?: Maybe<Scalars['String']>;
  /** Parte testuale inferiore */
  descriptionFooterEn?: Maybe<Scalars['String']>;
  /** Parte testuale inferiore */
  descriptionFooterEs?: Maybe<Scalars['String']>;
  /** Parte testuale inferiore */
  descriptionFooterFr?: Maybe<Scalars['String']>;
  /** Parte testuale inferiore */
  descriptionFooterIt?: Maybe<Scalars['String']>;
  /** Parte testuale inferiore */
  descriptionFooterUs?: Maybe<Scalars['String']>;
  /** Parte testuale inferiore */
  descriptionFooterUsEs?: Maybe<Scalars['String']>;
  /** Parte testuale inferiore */
  descriptionFooterUsFr?: Maybe<Scalars['String']>;
  /** Parte testuale superiore */
  descriptionHead?: Maybe<Scalars['String']>;
  /** Parte testuale superiore */
  descriptionHeadDe?: Maybe<Scalars['String']>;
  /** Parte testuale superiore */
  descriptionHeadEn?: Maybe<Scalars['String']>;
  /** Parte testuale superiore */
  descriptionHeadEs?: Maybe<Scalars['String']>;
  /** Parte testuale superiore */
  descriptionHeadFr?: Maybe<Scalars['String']>;
  /** Parte testuale superiore */
  descriptionHeadIt?: Maybe<Scalars['String']>;
  /** Parte testuale superiore */
  descriptionHeadUs?: Maybe<Scalars['String']>;
  /** Parte testuale superiore */
  descriptionHeadUsEs?: Maybe<Scalars['String']>;
  /** Parte testuale superiore */
  descriptionHeadUsFr?: Maybe<Scalars['String']>;
  gallery?: Maybe<Array<Maybe<GalleryItemNode>>>;
  galleryImages: Array<GalleryItemNode>;
  id: Scalars['ID'];
  imageAlt?: Maybe<Scalars['String']>;
  imagePath: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  /** Make this content visible in the footure for this language */
  inFooter: Scalars['Boolean'];
  /** Make this content visible in the footure for this language */
  inFooterDe: Scalars['Boolean'];
  /** Make this content visible in the footure for this language */
  inFooterEn: Scalars['Boolean'];
  /** Make this content visible in the footure for this language */
  inFooterEs: Scalars['Boolean'];
  /** Make this content visible in the footure for this language */
  inFooterFr: Scalars['Boolean'];
  /** Make this content visible in the footure for this language */
  inFooterIt: Scalars['Boolean'];
  /** Make this content visible in the footure for this language */
  inFooterUs: Scalars['Boolean'];
  /** Make this content visible in the footure for this language */
  inFooterUsEs: Scalars['Boolean'];
  /** Make this content visible in the footure for this language */
  inFooterUsFr: Scalars['Boolean'];
  /** Make this content visible in home for this language */
  inHome: Scalars['Boolean'];
  /** Make this content visible in home for this language */
  inHomeDe: Scalars['Boolean'];
  /** Make this content visible in home for this language */
  inHomeEn: Scalars['Boolean'];
  /** Make this content visible in home for this language */
  inHomeEs: Scalars['Boolean'];
  /** Make this content visible in home for this language */
  inHomeFr: Scalars['Boolean'];
  /** Make this content visible in home for this language */
  inHomeIt: Scalars['Boolean'];
  /** Make this content visible in home for this language */
  inHomeUs: Scalars['Boolean'];
  /** Make this content visible in home for this language */
  inHomeUsEs: Scalars['Boolean'];
  /** Make this content visible in home for this language */
  inHomeUsFr: Scalars['Boolean'];
  magazinebrands: Array<BrandNode>;
  magazinecollezioni: Array<CollezioneNode>;
  magazineprogetti: Array<ProgettiNode>;
  mainImage?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  pagina?: Maybe<PaginaNode>;
  pk?: Maybe<Scalars['Int']>;
  /** idold */
  placeholderId: Scalars['Int'];
  premio?: Maybe<Scalars['String']>;
  previewImage?: Maybe<Scalars['String']>;
  pubDate?: Maybe<Scalars['DateTime']>;
  pubblicato?: Maybe<Scalars['Boolean']>;
  /** H2 - Massimo 150 caratteri */
  seoDescription?: Maybe<Scalars['String']>;
  /** H2 - Massimo 150 caratteri */
  seoDescriptionDe?: Maybe<Scalars['String']>;
  /** H2 - Massimo 150 caratteri */
  seoDescriptionEn?: Maybe<Scalars['String']>;
  /** H2 - Massimo 150 caratteri */
  seoDescriptionEs?: Maybe<Scalars['String']>;
  /** H2 - Massimo 150 caratteri */
  seoDescriptionFr?: Maybe<Scalars['String']>;
  /** H2 - Massimo 150 caratteri */
  seoDescriptionIt?: Maybe<Scalars['String']>;
  /** H2 - Massimo 150 caratteri */
  seoDescriptionUs?: Maybe<Scalars['String']>;
  /** H2 - Massimo 150 caratteri */
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  /** H2 - Massimo 150 caratteri */
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  /** H1 - Massimo 70 caratteri */
  seoTitle?: Maybe<Scalars['String']>;
  /** H1 - Massimo 70 caratteri */
  seoTitleDe?: Maybe<Scalars['String']>;
  /** H1 - Massimo 70 caratteri */
  seoTitleEn?: Maybe<Scalars['String']>;
  /** H1 - Massimo 70 caratteri */
  seoTitleEs?: Maybe<Scalars['String']>;
  /** H1 - Massimo 70 caratteri */
  seoTitleFr?: Maybe<Scalars['String']>;
  /** H1 - Massimo 70 caratteri */
  seoTitleIt?: Maybe<Scalars['String']>;
  /** H1 - Massimo 70 caratteri */
  seoTitleUs?: Maybe<Scalars['String']>;
  /** H1 - Massimo 70 caratteri */
  seoTitleUsEs?: Maybe<Scalars['String']>;
  /** H1 - Massimo 70 caratteri */
  seoTitleUsFr?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  subtitleDe?: Maybe<Scalars['String']>;
  subtitleEn?: Maybe<Scalars['String']>;
  subtitleEs?: Maybe<Scalars['String']>;
  subtitleFr?: Maybe<Scalars['String']>;
  subtitleIt?: Maybe<Scalars['String']>;
  subtitleUs?: Maybe<Scalars['String']>;
  subtitleUsEs?: Maybe<Scalars['String']>;
  subtitleUsFr?: Maybe<Scalars['String']>;
  thumbnailPath: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  /** Max 100 caratteri - Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Max 100 caratteri - Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Max 100 caratteri - Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Max 100 caratteri - Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  /** Max 100 caratteri - Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Max 100 caratteri - Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Max 100 caratteri - Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Max 100 caratteri - Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  validityFrom?: Maybe<Scalars['DateTime']>;
  validityTo?: Maybe<Scalars['DateTime']>;
  videoUrl?: Maybe<Scalars['String']>;
  visibile?: Maybe<Scalars['Boolean']>;
  visibilitaAl?: Maybe<Scalars['String']>;
  visibilitaDal?: Maybe<Scalars['String']>;
  /** Make this content visible for this language */
  visible: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleDe: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEn: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleFr: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleIt: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsFr: Scalars['Boolean'];
  webguiId: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createContattoRivenditore?: Maybe<CreateContattoRivenditore>;
  helloMutation?: Maybe<Scalars['String']>;
};


export type MutationCreateContattoRivenditoreArgs = {
  input: ContattoRivenditoreInput;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID'];
};

export type OpusCodeNode = {
  __typename?: 'OpusCodeNode';
  articolo?: Maybe<ArticoliNode>;
  codiceCatalogo?: Maybe<Scalars['String']>;
  formato?: Maybe<FormatiNode>;
  id: Scalars['ID'];
  numPezzi?: Maybe<Scalars['Int']>;
  opus: OpusNode;
};

export type OpusNode = {
  __typename?: 'OpusNode';
  descrizione?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageAlt?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  opusCodesPerArticoli?: Maybe<Array<Maybe<OpusCodeNode>>>;
  opusCodesPerFormati?: Maybe<Array<Maybe<OpusCodeNode>>>;
  opusOpuscode: Array<OpusCodeNode>;
  path?: Maybe<Scalars['String']>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PagebuilderPlaceholderNode = {
  __typename?: 'PagebuilderPlaceholderNode';
  created?: Maybe<Scalars['DateTime']>;
  draft: Scalars['Boolean'];
  id: Scalars['ID'];
  jsonDraft?: Maybe<Scalars['String']>;
  jsonPublished?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  lang?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  objectId?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum PagesPaginaStatoPubblicazioneChoices {
  /** Non Pubblicato */
  Nopubblicato = 'NOPUBBLICATO',
  /** Pubblicato */
  Pubblicato = 'PUBBLICATO'
}

/** An enumeration. */
export enum PagesPaginaTipologiaChoices {
  /** Pagina */
  Page = 'PAGE',
  /** Pagina applicazione */
  PageApp = 'PAGE_APP',
  /** Pagine Entità */
  PageAppMany = 'PAGE_APP_MANY'
}

export type PaginaNode = Node & {
  __typename?: 'PaginaNode';
  adminUrl?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  breadcrumbs?: Maybe<Array<Maybe<BreadcrumbType>>>;
  chiave?: Maybe<Scalars['String']>;
  chiaveMenu?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Maybe<PaginaNode>>>;
  created?: Maybe<Scalars['DateTime']>;
  descrizione?: Maybe<Scalars['String']>;
  descrizioneDe?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneFr?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  descrizioneUs?: Maybe<Scalars['String']>;
  descrizioneUsEs?: Maybe<Scalars['String']>;
  descrizioneUsFr?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  hreflangs?: Maybe<Array<Maybe<HrefLangType>>>;
  /** The ID of the object */
  id: Scalars['ID'];
  imageAlt?: Maybe<Scalars['String']>;
  inRicerca: Scalars['Boolean'];
  inSitemap: Scalars['Boolean'];
  mainImage?: Maybe<Scalars['String']>;
  menuChildren?: Maybe<Array<Maybe<PaginaNode>>>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modificaUrl?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  noindex: Scalars['Boolean'];
  nome?: Maybe<Scalars['String']>;
  nomeDe?: Maybe<Scalars['String']>;
  nomeEn?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeFr?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  nomeUs?: Maybe<Scalars['String']>;
  nomeUsEs?: Maybe<Scalars['String']>;
  nomeUsFr?: Maybe<Scalars['String']>;
  pageActive: Scalars['Boolean'];
  pageActiveDe: Scalars['Boolean'];
  pageActiveEn: Scalars['Boolean'];
  pageActiveEs: Scalars['Boolean'];
  pageActiveFr: Scalars['Boolean'];
  pageActiveIt: Scalars['Boolean'];
  pageActiveUs: Scalars['Boolean'];
  pageActiveUsEs: Scalars['Boolean'];
  pageActiveUsFr: Scalars['Boolean'];
  pagebuilders?: Maybe<Array<Maybe<PagebuilderPlaceholderNode>>>;
  pagina?: Maybe<PaginaNode>;
  parent?: Maybe<PaginaNode>;
  path?: Maybe<Scalars['String']>;
  pathDe?: Maybe<Scalars['String']>;
  pathEn?: Maybe<Scalars['String']>;
  pathEs?: Maybe<Scalars['String']>;
  pathFr?: Maybe<Scalars['String']>;
  pathIt?: Maybe<Scalars['String']>;
  pathUs?: Maybe<Scalars['String']>;
  pathUsEs?: Maybe<Scalars['String']>;
  pathUsFr?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  previewImage?: Maybe<Scalars['String']>;
  pubblicato?: Maybe<Scalars['Boolean']>;
  seo?: Maybe<SeoType>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  siblings?: Maybe<Array<Maybe<PaginaNode>>>;
  slug?: Maybe<Scalars['String']>;
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  statoPubblicazione: PagesPaginaStatoPubblicazioneChoices;
  template?: Maybe<Scalars['String']>;
  tipologia: PagesPaginaTipologiaChoices;
  titolo: Scalars['String'];
  titoloDe?: Maybe<Scalars['String']>;
  titoloEn?: Maybe<Scalars['String']>;
  titoloEs?: Maybe<Scalars['String']>;
  titoloFr?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
  titoloUs?: Maybe<Scalars['String']>;
  titoloUsEs?: Maybe<Scalars['String']>;
  titoloUsFr?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  visibile?: Maybe<Scalars['Boolean']>;
  visibilitaAl?: Maybe<Scalars['String']>;
  visibilitaDal?: Maybe<Scalars['String']>;
};

export type PaginaNodeConnection = {
  __typename?: 'PaginaNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaginaNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PaginaNode` and its cursor. */
export type PaginaNodeEdge = {
  __typename?: 'PaginaNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PaginaNode>;
};

/** An enumeration. */
export enum ProdottiBrandStatoPubblicazioneChoices {
  /** Non Pubblicato */
  Nopubblicato = 'NOPUBBLICATO',
  /** Pubblicato */
  Pubblicato = 'PUBBLICATO'
}

export type ProfessioniObject = {
  __typename?: 'ProfessioniObject';
  codice?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ProgettiNode = {
  __typename?: 'ProgettiNode';
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  /** altri_materiali progetti marazzi site */
  altriMateriali?: Maybe<Scalars['Boolean']>;
  /** anno progetti marazzi site */
  anno?: Maybe<Scalars['Int']>;
  breadcrumbs?: Maybe<Array<Maybe<BreadcrumbType>>>;
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  cittaId?: Maybe<Scalars['String']>;
  collezioni?: Maybe<Array<Maybe<CollezioneNode>>>;
  copertina?: Maybe<Scalars['String']>;
  correlati?: Maybe<Array<Maybe<ProgettiNode>>>;
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Main textual description of your content */
  description?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionDe?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEn?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEs?: Maybe<Scalars['String']>;
  /** Footer description of your content */
  descriptionFooter?: Maybe<Scalars['String']>;
  /** Footer description of your content */
  descriptionFooterDe?: Maybe<Scalars['String']>;
  /** Footer description of your content */
  descriptionFooterEn?: Maybe<Scalars['String']>;
  /** Footer description of your content */
  descriptionFooterEs?: Maybe<Scalars['String']>;
  /** Footer description of your content */
  descriptionFooterFr?: Maybe<Scalars['String']>;
  /** Footer description of your content */
  descriptionFooterIt?: Maybe<Scalars['String']>;
  /** Footer description of your content */
  descriptionFooterUs?: Maybe<Scalars['String']>;
  /** Footer description of your content */
  descriptionFooterUsEs?: Maybe<Scalars['String']>;
  /** Footer description of your content */
  descriptionFooterUsFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionIt?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsFr?: Maybe<Scalars['String']>;
  destinazione?: Maybe<Scalars['String']>;
  destinazioneTitolo?: Maybe<Scalars['String']>;
  destinazioni?: Maybe<Array<Maybe<DestinazioneUsoNode>>>;
  galleryProgetti: Array<ImmaginiProgettiNode>;
  galleryProgettoDetail?: Maybe<Array<Maybe<ImmaginiProgettiNode>>>;
  /** id progetti marazzi site */
  id: Scalars['Int'];
  imageAlt?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  /** Indirizzo of the progetti marazzi site */
  indirizzo?: Maybe<Scalars['String']>;
  infoProgetti: Array<InfoProgettoNode>;
  infoProgettiCollezione?: Maybe<Array<Maybe<InfoProgettoCollezioneObject>>>;
  /** Link of the progetti marazzi site */
  link?: Maybe<Scalars['String']>;
  magazineprogetti: Array<MagazineNode>;
  /** marazzi_engineering progetti marazzi site */
  marazziEngineering?: Maybe<Scalars['Boolean']>;
  modelPk?: Maybe<Scalars['Int']>;
  /** Name of the progetti marazzi site */
  name?: Maybe<Scalars['String']>;
  /** progressivo progetti marazzi site */
  ordinamentoWeb?: Maybe<Scalars['Int']>;
  pk?: Maybe<Scalars['Int']>;
  premio?: Maybe<Scalars['String']>;
  progettiCollezioni: Array<CollezioneNode>;
  progettiProgetti: Array<ProgettiNode>;
  progettiSet: Array<ProgettiNode>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  soluzioni: Array<SoluzioneNode>;
  sottocategorieprogetti: Array<SottoCategorieNode>;
  /** Sottotitolo of your content */
  sottotitolo?: Maybe<Scalars['String']>;
  /** Sottotitolo of your content */
  sottotitoloDe?: Maybe<Scalars['String']>;
  /** Sottotitolo of your content */
  sottotitoloEn?: Maybe<Scalars['String']>;
  /** Sottotitolo of your content */
  sottotitoloEs?: Maybe<Scalars['String']>;
  /** Sottotitolo of your content */
  sottotitoloFr?: Maybe<Scalars['String']>;
  /** Sottotitolo of your content */
  sottotitoloIt?: Maybe<Scalars['String']>;
  /** Sottotitolo of your content */
  sottotitoloUs?: Maybe<Scalars['String']>;
  /** Sottotitolo of your content */
  sottotitoloUsEs?: Maybe<Scalars['String']>;
  /** Sottotitolo of your content */
  sottotitoloUsFr?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  tecnologie: Array<TecnologiaNode>;
  title?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescription?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEn?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionFr?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionIt?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  /** Titolo of your content */
  titolo?: Maybe<Scalars['String']>;
  /** Titolo of your content */
  titoloDe?: Maybe<Scalars['String']>;
  /** Titolo of your content */
  titoloEn?: Maybe<Scalars['String']>;
  /** Titolo of your content */
  titoloEs?: Maybe<Scalars['String']>;
  /** Titolo of your content */
  titoloFr?: Maybe<Scalars['String']>;
  /** Titolo of your content */
  titoloIt?: Maybe<Scalars['String']>;
  /** Titolo of your content */
  titoloUs?: Maybe<Scalars['String']>;
  /** Titolo of your content */
  titoloUsEs?: Maybe<Scalars['String']>;
  /** Titolo of your content */
  titoloUsFr?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  /** Make this content visible for this language */
  visible?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleDe?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleEn?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleEs?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleFr?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleIt?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleUs?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleUsEs?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleUsFr?: Maybe<Scalars['Boolean']>;
  /** visualizza_web progetti marazzi site */
  visualizzaWeb?: Maybe<Scalars['Boolean']>;
};

export type Query = {
  __typename?: 'Query';
  allCaratteristiche?: Maybe<Array<Maybe<CaratteristicheAllCustomObject>>>;
  allCaratteristichePadre?: Maybe<Array<Maybe<CaratteristichePadreNode>>>;
  allCategorieMagazine?: Maybe<Array<Maybe<CategoriaMagazineNode>>>;
  allMagazine?: Maybe<Array<Maybe<MagazineNode>>>;
  allTonalita?: Maybe<Array<Maybe<TonalitaCollezioneNode>>>;
  areaDownloadAzienda?: Maybe<Array<Maybe<DocumentiBrandNode>>>;
  areaDownloadCataloghiCollezioni?: Maybe<Array<Maybe<DocumentiCollezioniNode>>>;
  areaDownloadCataloghiGenerali?: Maybe<Array<Maybe<DocumentiBrandNode>>>;
  audioDescrizione?: Maybe<AudioDescrizioneNode>;
  brand?: Maybe<BrandNode>;
  brands?: Maybe<Array<Maybe<BrandNode>>>;
  categoria?: Maybe<CategoriaNode>;
  categorieProgetti?: Maybe<Array<Maybe<SottoCategorieNode>>>;
  citta?: Maybe<Array<Maybe<LocalitaNode>>>;
  cittaSingolare?: Maybe<LocalitaNode>;
  collezione?: Maybe<CollezioneNode>;
  collezioni?: Maybe<Array<Maybe<CollezioneNode>>>;
  effetti?: Maybe<Array<Maybe<CategoriaNode>>>;
  effettiPerCategoria?: Maybe<Array<Maybe<MagazineNode>>>;
  magazine?: Maybe<MagazineNode>;
  magazineEvidenza?: Maybe<Array<Maybe<MagazineNode>>>;
  magazineHomepage?: Maybe<Array<Maybe<MagazineNode>>>;
  me?: Maybe<UtenteNode>;
  pagina?: Maybe<PaginaNode>;
  pagine?: Maybe<PaginaNodeConnection>;
  professioni?: Maybe<Array<Maybe<ProfessioniObject>>>;
  progetti?: Maybe<Array<Maybe<ProgettiNode>>>;
  progettiEvidenza?: Maybe<Array<Maybe<ProgettiNode>>>;
  progetto?: Maybe<ProgettiNode>;
  province?: Maybe<Array<Maybe<LocalitaNode>>>;
  provincia?: Maybe<LocalitaNode>;
  regione?: Maybe<LocalitaNode>;
  regioni?: Maybe<Array<Maybe<LocalitaNode>>>;
  rivenditore?: Maybe<ClienteNode>;
  rivenditori?: Maybe<Array<Maybe<ClienteNode>>>;
  soluzione?: Maybe<SoluzioneNode>;
  soluzioni?: Maybe<Array<Maybe<SoluzioneNode>>>;
  sostenibilitaCodiceEtico?: Maybe<Array<Maybe<DocumentiBrandNode>>>;
  sostenibilitaPoliticaAziendale?: Maybe<Array<Maybe<DocumentiBrandNode>>>;
  tecnologia?: Maybe<TecnologiaNode>;
  tecnologie?: Maybe<Array<Maybe<TecnologiaNode>>>;
  tonalita?: Maybe<TonalitaDetailObject>;
  ultimeCollezioni?: Maybe<Array<Maybe<CollezioneNode>>>;
};


export type QueryAudioDescrizioneArgs = {
  slug: Scalars['String'];
};


export type QueryBrandArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryCategoriaArgs = {
  slug1?: InputMaybe<Scalars['String']>;
  slug2?: InputMaybe<Scalars['String']>;
};


export type QueryCittaArgs = {
  provincia: Scalars['String'];
};


export type QueryCittaSingolareArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryCollezioneArgs = {
  brand?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryEffettiPerCategoriaArgs = {
  categoriaId?: InputMaybe<Scalars['Int']>;
};


export type QueryMagazineArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryPaginaArgs = {
  chiave?: InputMaybe<Scalars['String']>;
  contentTypeId?: InputMaybe<Scalars['Int']>;
  objectId?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  withChildren?: InputMaybe<Scalars['Boolean']>;
  withMenuChildren?: InputMaybe<Scalars['Boolean']>;
  withSiblings?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPagineArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tipologia?: InputMaybe<PagesPaginaTipologiaChoices>;
};


export type QueryProgettoArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryProvinceArgs = {
  regione: Scalars['String'];
};


export type QueryProvinciaArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryRegioneArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryRivenditoreArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryRivenditoriArgs = {
  citta?: InputMaybe<Scalars['String']>;
  provincia?: InputMaybe<Scalars['String']>;
  regione?: InputMaybe<Scalars['String']>;
};


export type QuerySoluzioneArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryTecnologiaArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryTonalitaArgs = {
  brand?: InputMaybe<Scalars['String']>;
  collezione?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type SeoType = {
  __typename?: 'SeoType';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  noindex?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type ShadeVariationNode = {
  __typename?: 'ShadeVariationNode';
  active?: Maybe<Scalars['Boolean']>;
  codice?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
};

export type SoluzioneNode = {
  __typename?: 'SoluzioneNode';
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  adminUrl?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  altDe?: Maybe<Scalars['String']>;
  altEn?: Maybe<Scalars['String']>;
  altEs?: Maybe<Scalars['String']>;
  altFr?: Maybe<Scalars['String']>;
  altIt?: Maybe<Scalars['String']>;
  altUs?: Maybe<Scalars['String']>;
  altUsEs?: Maybe<Scalars['String']>;
  altUsFr?: Maybe<Scalars['String']>;
  categorie?: Maybe<Array<Maybe<CategoriaNode>>>;
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  correlati?: Maybe<Array<Maybe<SoluzioneNode>>>;
  created?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Main textual description of your content */
  description?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionDe?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEn?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionIt?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsFr?: Maybe<Scalars['String']>;
  descrizione?: Maybe<Scalars['String']>;
  destinazioniUso?: Maybe<Array<Maybe<DestinazioneSoluzioneNode>>>;
  destinazionisoluzioni: Array<DestinazioneSoluzioneNode>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imageAlt?: Maybe<Scalars['String']>;
  linkVideo?: Maybe<Scalars['String']>;
  linkVideoDe?: Maybe<Scalars['String']>;
  linkVideoEn?: Maybe<Scalars['String']>;
  linkVideoEs?: Maybe<Scalars['String']>;
  linkVideoFr?: Maybe<Scalars['String']>;
  linkVideoIt?: Maybe<Scalars['String']>;
  linkVideoUs?: Maybe<Scalars['String']>;
  linkVideoUsEs?: Maybe<Scalars['String']>;
  linkVideoUsFr?: Maybe<Scalars['String']>;
  macroCategorie?: Maybe<Array<Maybe<MacroCategoriaNode>>>;
  macroCategories: Array<MacroCategoriaNode>;
  mainImage?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  noindex: Scalars['Boolean'];
  ordinamento?: Maybe<Scalars['Int']>;
  pageActive: Scalars['Boolean'];
  pagebuilders?: Maybe<Array<Maybe<PagebuilderPlaceholderNode>>>;
  pagina?: Maybe<PaginaNode>;
  pk?: Maybe<Scalars['Int']>;
  placeholderId: Scalars['Int'];
  previewImage?: Maybe<Scalars['String']>;
  progetti: Array<ProgettiNode>;
  pubblicato?: Maybe<Scalars['Boolean']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  statoPubblicazione: SoluzioniSoluzioneStatoPubblicazioneChoices;
  subtitle?: Maybe<Scalars['String']>;
  subtitleH1?: Maybe<Scalars['String']>;
  subtitleH1De?: Maybe<Scalars['String']>;
  subtitleH1En?: Maybe<Scalars['String']>;
  subtitleH1Es?: Maybe<Scalars['String']>;
  subtitleH1Fr?: Maybe<Scalars['String']>;
  subtitleH1It?: Maybe<Scalars['String']>;
  subtitleH1Us?: Maybe<Scalars['String']>;
  subtitleH1UsEs?: Maybe<Scalars['String']>;
  subtitleH1UsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  title: Scalars['String'];
  /** Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescription?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEn?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionFr?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionIt?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  titleH1?: Maybe<Scalars['String']>;
  titleH1De?: Maybe<Scalars['String']>;
  titleH1En?: Maybe<Scalars['String']>;
  titleH1Es?: Maybe<Scalars['String']>;
  titleH1Fr?: Maybe<Scalars['String']>;
  titleH1It?: Maybe<Scalars['String']>;
  titleH1Us?: Maybe<Scalars['String']>;
  titleH1UsEs?: Maybe<Scalars['String']>;
  titleH1UsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  titolo: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  visibile?: Maybe<Scalars['Boolean']>;
  visibilitaAl?: Maybe<Scalars['String']>;
  visibilitaDal?: Maybe<Scalars['String']>;
  /** Make this content visible for this language */
  visible: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleDe: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEn: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleFr: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleIt: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsFr: Scalars['Boolean'];
};

/** An enumeration. */
export enum SoluzioniSoluzioneStatoPubblicazioneChoices {
  /** Non Pubblicato */
  Nopubblicato = 'NOPUBBLICATO',
  /** Pubblicato */
  Pubblicato = 'PUBBLICATO'
}

export type SottoCategorieNode = {
  __typename?: 'SottoCategorieNode';
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  /** code */
  codice: Scalars['String'];
  /** id */
  id: Scalars['Int'];
  /** nome */
  nome: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  sottocategorieprogetti: Array<ProgettiNode>;
  title?: Maybe<Scalars['String']>;
  /** title sottocategoria website marazzi site */
  titleDe?: Maybe<Scalars['String']>;
  /** title sottocategoria website marazzi site */
  titleEn?: Maybe<Scalars['String']>;
  /** title sottocategoria website marazzi site */
  titleEs?: Maybe<Scalars['String']>;
  /** title sottocategoria website marazzi site */
  titleFr?: Maybe<Scalars['String']>;
  /** title sottocategoria website marazzi site */
  titleIt?: Maybe<Scalars['String']>;
  /** title sottocategoria website marazzi site */
  titleUs?: Maybe<Scalars['String']>;
  /** title sottocategoria website marazzi site */
  titleUsEs?: Maybe<Scalars['String']>;
  /** title sottocategoria website marazzi site */
  titleUsFr?: Maybe<Scalars['String']>;
};

export type SpessoriFormatiObject = {
  __typename?: 'SpessoriFormatiObject';
  codice?: Maybe<Scalars['String']>;
  formati?: Maybe<Array<Maybe<FormatiSpessoriObject>>>;
  spessore?: Maybe<Scalars['String']>;
};

export type SuperficiObject = {
  __typename?: 'SuperficiObject';
  bcra?: Maybe<Scalars['String']>;
  dcof?: Maybe<Scalars['String']>;
  dinscivolosita?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  nome?: Maybe<Scalars['String']>;
  pendoloAS4586?: Maybe<Scalars['String']>;
  pendoloBS7976?: Maybe<Scalars['String']>;
  pendoloUNE41901?: Maybe<Scalars['String']>;
  scivolositaLabel?: Maybe<Scalars['String']>;
  scivolositaNome?: Maybe<Scalars['String']>;
  specificheAbcLabel?: Maybe<Scalars['String']>;
  specificheAbcNome?: Maybe<Scalars['String']>;
  spessori?: Maybe<Array<Maybe<SpessoriFormatiObject>>>;
};

export type SuperficieNode = {
  __typename?: 'SuperficieNode';
  descrizione?: Maybe<Scalars['String']>;
  descrizioneDe?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneFr?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  descrizioneUs?: Maybe<Scalars['String']>;
  descrizioneUsEs?: Maybe<Scalars['String']>;
  descrizioneUsFr?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  infoProgetti: Array<InfoProgettoNode>;
  nome: Scalars['String'];
  nomeDe?: Maybe<Scalars['String']>;
  nomeEn?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeFr?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  nomeUs?: Maybe<Scalars['String']>;
  nomeUsEs?: Maybe<Scalars['String']>;
  nomeUsFr?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  superficiarticoli: Array<ArticoliNode>;
  superficieArticles: Array<ArticoliNode>;
};

export type TecnologiaNode = {
  __typename?: 'TecnologiaNode';
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  adminUrl?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  altDe?: Maybe<Scalars['String']>;
  altEn?: Maybe<Scalars['String']>;
  altEs?: Maybe<Scalars['String']>;
  altFr?: Maybe<Scalars['String']>;
  altIt?: Maybe<Scalars['String']>;
  altUs?: Maybe<Scalars['String']>;
  altUsEs?: Maybe<Scalars['String']>;
  altUsFr?: Maybe<Scalars['String']>;
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  correlati?: Maybe<Array<Maybe<TecnologiaNode>>>;
  created?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Main textual description of your content */
  description?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionDe?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEn?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionIt?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsFr?: Maybe<Scalars['String']>;
  descrizione?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imageAlt?: Maybe<Scalars['String']>;
  linkVideo?: Maybe<Scalars['String']>;
  linkVideoDe?: Maybe<Scalars['String']>;
  linkVideoEn?: Maybe<Scalars['String']>;
  linkVideoEs?: Maybe<Scalars['String']>;
  linkVideoFr?: Maybe<Scalars['String']>;
  linkVideoIt?: Maybe<Scalars['String']>;
  linkVideoUs?: Maybe<Scalars['String']>;
  linkVideoUsEs?: Maybe<Scalars['String']>;
  linkVideoUsFr?: Maybe<Scalars['String']>;
  listingImage?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  noindex: Scalars['Boolean'];
  ordinamento?: Maybe<Scalars['Int']>;
  pageActive: Scalars['Boolean'];
  pagebuilders?: Maybe<Array<Maybe<PagebuilderPlaceholderNode>>>;
  pagina?: Maybe<PaginaNode>;
  pk?: Maybe<Scalars['Int']>;
  placeholderId: Scalars['Int'];
  previewImage?: Maybe<Scalars['String']>;
  progetti: Array<ProgettiNode>;
  pubblicato?: Maybe<Scalars['Boolean']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  statoPubblicazione: TecnologieTecnologiaStatoPubblicazioneChoices;
  subtitle?: Maybe<Scalars['String']>;
  subtitleH1?: Maybe<Scalars['String']>;
  subtitleH1De?: Maybe<Scalars['String']>;
  subtitleH1En?: Maybe<Scalars['String']>;
  subtitleH1Es?: Maybe<Scalars['String']>;
  subtitleH1Fr?: Maybe<Scalars['String']>;
  subtitleH1It?: Maybe<Scalars['String']>;
  subtitleH1Us?: Maybe<Scalars['String']>;
  subtitleH1UsEs?: Maybe<Scalars['String']>;
  subtitleH1UsFr?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescription?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEn?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionFr?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionIt?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  titleH1?: Maybe<Scalars['String']>;
  titleH1De?: Maybe<Scalars['String']>;
  titleH1En?: Maybe<Scalars['String']>;
  titleH1Es?: Maybe<Scalars['String']>;
  titleH1Fr?: Maybe<Scalars['String']>;
  titleH1It?: Maybe<Scalars['String']>;
  titleH1Us?: Maybe<Scalars['String']>;
  titleH1UsEs?: Maybe<Scalars['String']>;
  titleH1UsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  titolo: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  visibile?: Maybe<Scalars['Boolean']>;
  visibilitaAl?: Maybe<Scalars['String']>;
  visibilitaDal?: Maybe<Scalars['String']>;
  /** Make this content visible for this language */
  visible: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleDe: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEn: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleFr: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleIt: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsFr: Scalars['Boolean'];
};

/** An enumeration. */
export enum TecnologieTecnologiaStatoPubblicazioneChoices {
  /** Non Pubblicato */
  Nopubblicato = 'NOPUBBLICATO',
  /** Pubblicato */
  Pubblicato = 'PUBBLICATO'
}

export type TipologieNode = {
  __typename?: 'TipologieNode';
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  codice?: Maybe<Scalars['String']>;
  documentiBrand: Array<DocumentiBrandNode>;
  downloadWeb?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  nome?: Maybe<Scalars['String']>;
  onlineWeb?: Maybe<Scalars['Boolean']>;
  ordinamentoWeb?: Maybe<Scalars['Int']>;
  tipologiedocumenti: Array<DocumentiCollezioniNode>;
  title?: Maybe<Scalars['String']>;
  titleDe?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  titleEs?: Maybe<Scalars['String']>;
  titleFr?: Maybe<Scalars['String']>;
  titleIt?: Maybe<Scalars['String']>;
  titleUs?: Maybe<Scalars['String']>;
  titleUsEs?: Maybe<Scalars['String']>;
  titleUsFr?: Maybe<Scalars['String']>;
  visualizzaArticoli?: Maybe<Scalars['Boolean']>;
  visualizzaCollezioni?: Maybe<Scalars['Boolean']>;
  visualizzaProgetti?: Maybe<Scalars['Boolean']>;
};

export type TonalitaCollezioneNode = {
  __typename?: 'TonalitaCollezioneNode';
  articolo?: Maybe<ArticoliNode>;
  breadcrumbs?: Maybe<Array<Maybe<BreadcrumbType>>>;
  certificazioni?: Maybe<Array<Maybe<CaratteristicheNode>>>;
  collezione: CollezioneNode;
  gallery?: Maybe<Array<Maybe<ImmaginiCollezioniNode>>>;
  id: Scalars['ID'];
  modelPk?: Maybe<Scalars['Int']>;
  ordinamento?: Maybe<Scalars['Int']>;
  pk?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  slugBrand?: Maybe<Scalars['String']>;
  slugCollezione?: Maybe<Scalars['String']>;
  superficiSpessoriFormati?: Maybe<Array<Maybe<SuperficiObject>>>;
  tonalita: TonalitaNode;
  tonalitaNome?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TonalitaColoriImageObject = {
  __typename?: 'TonalitaColoriImageObject';
  alt?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TonalitaColoriObject = {
  __typename?: 'TonalitaColoriObject';
  image?: Maybe<TonalitaColoriImageObject>;
  nome?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TonalitaDetailObject = {
  __typename?: 'TonalitaDetailObject';
  brand?: Maybe<BrandNode>;
  collezione?: Maybe<CollezioneNode>;
  imageCollezione?: Maybe<ImmaginiCollezioniNode>;
  tonalita?: Maybe<TonalitaNode>;
  tonalitaCollezione?: Maybe<TonalitaCollezioneNode>;
};

export type TonalitaNode = {
  __typename?: 'TonalitaNode';
  active?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  infoProgetti: Array<InfoProgettoNode>;
  nome?: Maybe<Scalars['String']>;
  pagina?: Maybe<PaginaNode>;
  pk?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  tonalitaArticles: Array<ArticoliNode>;
  tonalitacollezioni: Array<CollezioneNode>;
  /** Make this content visible for this language */
  visible?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleDe?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleEn?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleEs?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleFr?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleIt?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleUs?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleUsEs?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleUsFr?: Maybe<Scalars['Boolean']>;
  xTonalitaCollezioni: Array<TonalitaCollezioneNode>;
};

export type UtenteNode = Node & {
  __typename?: 'UtenteNode';
  cognome?: Maybe<Scalars['String']>;
  dateJoined: Scalars['DateTime'];
  edit?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  /** Stabilisce se l'utente debba essere considerato attivo. Deseleziona qui, piuttosto che cancellare gli account. */
  isActive: Scalars['Boolean'];
  /** Stabilisce se l'utente può accedere a questo sito di amministrazione. */
  isStaff: Scalars['Boolean'];
  /** Attribuisce all'utente tutti i privilegi, senza che sia necessario assegnarli esplicitamente. */
  isSuperuser: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  magazineMagazineChangedByRelated: Array<MagazineNode>;
  magazineMagazineOwnerRelated: Array<MagazineNode>;
  nome?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  prodottiArticoliChangedByRelated: Array<ArticoliNode>;
  prodottiArticoliOwnerRelated: Array<ArticoliNode>;
  prodottiBrandChangedByRelated: Array<BrandNode>;
  prodottiBrandOwnerRelated: Array<BrandNode>;
  prodottiCategoriaChangedByRelated: Array<CategoriaNode>;
  prodottiCategoriaOwnerRelated: Array<CategoriaNode>;
  prodottiCollezioniChangedByRelated: Array<CollezioneNode>;
  prodottiCollezioniOwnerRelated: Array<CollezioneNode>;
  prodottiIspirazioniChangedByRelated: Array<IspirazioniNode>;
  prodottiIspirazioniOwnerRelated: Array<IspirazioniNode>;
  prodottiMacrocategoriaChangedByRelated: Array<MacroCategoriaNode>;
  prodottiMacrocategoriaOwnerRelated: Array<MacroCategoriaNode>;
  prodottiProgettiChangedByRelated: Array<ProgettiNode>;
  prodottiProgettiOwnerRelated: Array<ProgettiNode>;
  showToolbar?: Maybe<Scalars['Boolean']>;
  soluzioniSoluzioneChangedByRelated: Array<SoluzioneNode>;
  soluzioniSoluzioneOwnerRelated: Array<SoluzioneNode>;
  tecnologieTecnologiaChangedByRelated: Array<TecnologiaNode>;
  tecnologieTecnologiaOwnerRelated: Array<TecnologiaNode>;
  /** Obbligatorio. 150 caratteri o meno.Solo lettere, cifre e @/./+/-/_ */
  username: Scalars['String'];
};

export type AreaDownloadCataloghiCollezioniQueryVariables = Exact<{ [key: string]: never; }>;


export type AreaDownloadCataloghiCollezioniQuery = { __typename?: 'Query', areaDownloadCataloghiCollezioni?: Array<{ __typename?: 'DocumentiCollezioniNode', id: number, nomeWeb?: string | null, url?: string | null, brand?: { __typename?: 'BrandNode', pk?: number | null, title?: string | null, url?: string | null } | null } | null> | null };

export type AreaDownloadCataloghiGeneraliQueryVariables = Exact<{ [key: string]: never; }>;


export type AreaDownloadCataloghiGeneraliQuery = { __typename?: 'Query', areaDownloadCataloghiGenerali?: Array<{ __typename?: 'DocumentiBrandNode', id?: number | null, nome?: string | null, url?: string | null, dataIns?: any | null, dataUltMod?: any | null, brand?: { __typename?: 'BrandNode', pk?: number | null, title?: string | null, slug: string } | null, tipologie?: { __typename?: 'TipologieNode', nome?: string | null, codice?: string | null } | null } | null> | null };

export type AreaDownloadAziendaQueryVariables = Exact<{ [key: string]: never; }>;


export type AreaDownloadAziendaQuery = { __typename?: 'Query', areaDownloadAzienda?: Array<{ __typename?: 'DocumentiBrandNode', id?: number | null, nome?: string | null, url?: string | null, dataIns?: any | null, dataUltMod?: any | null, tipologie?: { __typename?: 'TipologieNode', nome?: string | null, codice?: string | null } | null } | null> | null };

export type AudioDescrizioneQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type AudioDescrizioneQuery = { __typename?: 'Query', audioDescrizione?: { __typename?: 'AudioDescrizioneNode', pk?: number | null, model?: number | null, title?: string | null, titolo?: string | null, slug?: string | null, collezione?: { __typename?: 'CollezioneNode', pk?: number | null, title: string, slug: string } | null, audioFiles?: Array<{ __typename?: 'AudioFileNode', pk?: number | null, cta?: string | null, fileUrl?: string | null } | null> | null } | null };

export type BrandQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type BrandQuery = { __typename?: 'Query', brand?: { __typename?: 'BrandNode', pk?: number | null, adminUrl?: string | null, visibile?: boolean | null, model?: number | null, modelClass?: string | null, pubblicato?: boolean | null, visibilitaDal?: string | null, visibilitaAl?: string | null, nome?: string | null, title?: string | null, slug: string, description?: string | null, immagineStatica?: string | null, immagineHome?: string | null, logoTransparent?: string | null, listingTitoloSeoH1?: string | null, listingTestoSeo?: string | null, correlati?: Array<{ __typename?: 'BrandNode', pk?: number | null, nome?: string | null, logo?: string | null, immagineStatica?: string | null, immagineHome?: string | null, logoTransparent?: string | null, url?: string | null, slug: string } | null> | null, collezioni?: Array<{ __typename?: 'CollezioneNode', pk?: number | null, nome?: string | null, title: string, slug: string, url?: string | null, categoriaEffetto?: { __typename?: 'CategoriaNode', slug: string } | null, brand?: { __typename?: 'BrandNode', nome?: string | null, slug: string } | null, listingImage?: { __typename?: 'ImmaginiCollezioniNode', url?: string | null, imageAlt?: string | null } | null } | null> | null, progetti?: Array<{ __typename?: 'ProgettiNode', name?: string | null, url?: string | null, title?: string | null, imageUrl?: string | null } | null> | null, magazines?: Array<{ __typename?: 'MagazineNode', pk?: number | null, title?: string | null, url?: string | null, description?: string | null, subtitle?: string | null, imageUrl?: string | null, tag?: string | null } | null> | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, pagina?: { __typename?: 'PaginaNode', pk?: number | null, chiave?: string | null, titolo: string, nome?: string | null, descrizione?: string | null, slug?: string | null, url?: string | null, previewImage?: string | null, mainImage?: string | null, hreflangs?: Array<{ __typename?: 'HrefLangType', hrefLang?: string | null, href?: string | null, locale?: string | null } | null> | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null } | null } | null, pagebuilders?: Array<{ __typename?: 'PagebuilderPlaceholderNode', key: string, text?: string | null, json_draft?: string | null, json_published?: string | null } | null> | null } | null };

export type BrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandsQuery = { __typename?: 'Query', brands?: Array<{ __typename?: 'BrandNode', pk?: number | null, nome?: string | null, slug: string, path?: string | null, logo?: string | null, url?: string | null, immagineHome?: string | null, logoTransparent?: string | null } | null> | null };

export type AllCaratteristicheQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCaratteristicheQuery = { __typename?: 'Query', allCaratteristiche?: Array<{ __typename?: 'CaratteristicheAllCustomObject', id?: number | null, title?: string | null, descrizione?: string | null, url?: string | null, logo?: string | null, children?: Array<{ __typename?: 'CaratteristicheNode', pk?: number | null, title?: string | null, url?: string | null, logo?: string | null, ambientale?: boolean | null } | null> | null } | null> | null };

export type CategoriaQueryVariables = Exact<{
  slug1?: InputMaybe<Scalars['String']>;
  slug2?: InputMaybe<Scalars['String']>;
}>;


export type CategoriaQuery = { __typename?: 'Query', categoria?: { __typename?: 'CategoriaNode', pk?: number | null, modelPk?: number | null, nome: string, slug: string, title: string, titleDescription?: string | null, description?: string | null, abstract?: string | null, voceMenu: string, titleTerzoLivello?: string | null, descriptionTerzoLivello?: string | null, objectId: number, macrocategoria?: { __typename?: 'MacroCategoriaNode', chiaveRicerca: string } | null } | null };

export type EffettiPerCategoriaQueryVariables = Exact<{
  categoriaId?: InputMaybe<Scalars['Int']>;
}>;


export type EffettiPerCategoriaQuery = { __typename?: 'Query', effettiPerCategoria?: Array<{ __typename?: 'MagazineNode', pk?: number | null, title?: string | null, slug?: string | null, categoriaTitle?: string | null, description?: string | null, imageUrl?: string | null, imageAlt?: string | null, url?: string | null } | null> | null };

export type CollezioniQueryVariables = Exact<{ [key: string]: never; }>;


export type CollezioniQuery = { __typename?: 'Query', collezioni?: Array<{ __typename?: 'CollezioneNode', pk?: number | null, nome?: string | null, description?: string | null, slug: string, title: string, brand?: { __typename?: 'BrandNode', slug: string } | null } | null> | null };

export type UltimeCollezioniQueryVariables = Exact<{ [key: string]: never; }>;


export type UltimeCollezioniQuery = { __typename?: 'Query', ultimeCollezioni?: Array<{ __typename?: 'CollezioneNode', pk?: number | null, title: string, url?: string | null, slug: string, categoriaEffetto?: { __typename?: 'CategoriaNode', slug: string } | null, brand?: { __typename?: 'BrandNode', nome?: string | null, slug: string } | null, listingImage?: { __typename?: 'ImmaginiCollezioniNode', url?: string | null, imageAlt?: string | null } | null } | null> | null };

export type EffettiQueryVariables = Exact<{ [key: string]: never; }>;


export type EffettiQuery = { __typename?: 'Query', effetti?: Array<{ __typename?: 'CategoriaNode', title: string, mainImage?: string | null, imageAlt?: string | null, url?: string | null } | null> | null };

export type CollezioneQueryVariables = Exact<{
  slug: Scalars['String'];
  brand: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type CollezioneQuery = { __typename?: 'Query', collezione?: { __typename?: 'CollezioneNode', pk?: number | null, modelPk?: number | null, nome?: string | null, title: string, sottotitolo?: string | null, description?: string | null, slug: string, quickship?: boolean | null, shield?: boolean | null, silktech?: boolean | null, novita?: boolean | null, nsf?: boolean | null, nsfMagazineSlug?: string | null, isUsa?: boolean | null, claim?: string | null, payoff?: string | null, logo?: string | null, url?: string | null, video?: string | null, linkVideo?: string | null, lappato?: boolean | null, lappatoUrl?: string | null, brand?: { __typename?: 'BrandNode', id: string, nome?: string | null, title?: string | null, slug: string } | null, gallery?: Array<{ __typename?: 'ImmaginiCollezioniNode', id?: number | null, url?: string | null, imageAlt?: string | null, articoliGallery?: Array<{ __typename?: 'ArticoliImmaginiCollezioniObject', pk?: number | null, image?: string | null, imageAlt?: string | null, tonalitaNome?: string | null, tonalitaUrl?: string | null, finituraNome?: string | null } | null> | null } | null> | null, abaco?: { __typename?: 'ImmaginiCollezioniNode', id?: number | null, url?: string | null } | null, immagineVideo?: { __typename?: 'ImmaginiCollezioniNode', id?: number | null, url?: string | null } | null, spessoriFormati?: Array<{ __typename?: 'SpessoriFormatiObject', spessore?: string | null, formati?: Array<{ __typename?: 'FormatiSpessoriObject', nome?: string | null, lato1Intero?: string | null, lato2Intero?: string | null, lato1Numeratore?: string | null, lato2Numeratore?: string | null, lato1Denominatore?: string | null, lato2Denominatore?: string | null } | null> | null } | null> | null, colori?: Array<{ __typename?: 'ColoriObject', id?: number | null, nome?: string | null, tonalita?: Array<{ __typename?: 'TonalitaColoriObject', nome?: string | null, url?: string | null, image?: { __typename?: 'TonalitaColoriImageObject', title?: string | null, alt?: string | null, url?: string | null } | null } | null> | null } | null> | null, superfici?: Array<{ __typename?: 'SuperficiObject', id?: number | null, nome?: string | null, dcof?: string | null, bcra?: string | null, pendoloAS4586?: string | null, pendoloBS7976?: string | null, pendoloUNE41901?: string | null, scivolositaNome?: string | null, scivolositaLabel?: string | null, specificheAbcNome?: string | null, specificheAbcLabel?: string | null } | null> | null, shadeVariations?: Array<{ __typename?: 'ShadeVariationNode', codice?: string | null, nome?: string | null, imageUrl?: string | null } | null> | null, destinazioni?: Array<{ __typename?: 'DestinazioneNode', nome?: string | null, titolo?: string | null, imageUrl?: string | null, imageAlt?: string | null } | null> | null, decori?: Array<{ __typename?: 'CategoriaDecoriObject', categoria?: string | null, decori?: Array<{ __typename?: 'DecoroObject', id?: number | null, categoriaDecoro?: string | null, nomeWeb?: string | null, styleWidth?: number | null, styleHeight?: number | null, image?: { __typename?: 'ImmaginiArticoliNode', id?: number | null, url?: string | null } | null } | null> | null } | null> | null, opuses?: Array<{ __typename?: 'OpusNode', nome?: string | null, descrizione?: string | null, imageUrl?: string | null, imageAlt?: string | null, opusCodesPerFormati?: Array<{ __typename?: 'OpusCodeNode', codiceCatalogo?: string | null, numPezzi?: number | null, formato?: { __typename?: 'FormatiNode', id?: number | null, nome?: string | null, lato1Cm?: string | null, lato2Cm?: string | null, lato1Intero?: string | null, lato2Intero?: string | null, lato1Numeratore?: string | null, lato2Numeratore?: string | null, lato1Denominatore?: string | null, lato2Denominatore?: string | null, lato1PxWeb?: string | null, lato2PxWeb?: string | null } | null, articolo?: { __typename?: 'ArticoliNode', id: number, tonalita?: { __typename?: 'TonalitaNode', nome?: string | null } | null, superficie?: { __typename?: 'SuperficieNode', nome: string } | null } | null } | null> | null, opusCodesPerArticoli?: Array<{ __typename?: 'OpusCodeNode', codiceCatalogo?: string | null, numPezzi?: number | null, formato?: { __typename?: 'FormatiNode', id?: number | null, nome?: string | null, lato1Cm?: string | null, lato2Cm?: string | null, lato1Intero?: string | null, lato2Intero?: string | null, lato1Numeratore?: string | null, lato2Numeratore?: string | null, lato1Denominatore?: string | null, lato2Denominatore?: string | null, lato1PxWeb?: string | null, lato2PxWeb?: string | null } | null, articolo?: { __typename?: 'ArticoliNode', id: number, tonalita?: { __typename?: 'TonalitaNode', nome?: string | null } | null, superficie?: { __typename?: 'SuperficieNode', nome: string } | null } | null } | null> | null } | null> | null, catalogo?: { __typename?: 'DocumentiCollezioniNode', nomeWeb?: string | null, url?: string | null } | null, cataloghiBrochure?: Array<{ __typename?: 'DocumentiCollezioniNode', nomeWeb?: string | null, url?: string | null } | null> | null, certificazioni?: Array<{ __typename?: 'CaratteristicheNode', pk?: number | null, title?: string | null, url?: string | null, logo?: string | null, ambientale?: boolean | null } | null> | null, progetti?: Array<{ __typename?: 'ProgettiNode', title?: string | null, destinazioneTitolo?: string | null, slug?: string | null, cittaId?: string | null, subtitle?: string | null, imageUrl?: string | null, imageAlt?: string | null, url?: string | null } | null> | null, effetto?: { __typename?: 'IspirazioniObject', title?: string | null, imageUrl?: string | null } | null, magazines?: Array<{ __typename?: 'MagazineNode', title?: string | null, slug?: string | null, categoriaTitle?: string | null, description?: string | null, imageUrl?: string | null, url?: string | null } | null> | null, categoriaEffetto?: { __typename?: 'CategoriaNode', pk?: number | null, title: string, abstract?: string | null, mainImage?: string | null, url?: string | null, slug: string } | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null } | null };

export type MagazineQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type MagazineQuery = { __typename?: 'Query', magazine?: { __typename?: 'MagazineNode', pk?: number | null, title?: string | null, pubDate?: any | null, imageUrl?: string | null, imageAlt?: string | null, descriptionHead?: string | null, descriptionFooter?: string | null, videoUrl?: string | null, premio?: string | null, model?: number | null, tag?: string | null, magazineprogetti: Array<{ __typename?: 'ProgettiNode', id: number, title?: string | null, url?: string | null }>, magazinecollezioni: Array<{ __typename?: 'CollezioneNode', pk?: number | null, title: string, url?: string | null, listingImage?: { __typename?: 'ImmaginiCollezioniNode', url?: string | null, imageAlt?: string | null } | null, brand?: { __typename?: 'BrandNode', pk?: number | null, logo?: string | null, logoTransparent?: string | null } | null }>, correlati?: Array<{ __typename?: 'MagazineNode', pk?: number | null, title?: string | null, pubDate?: any | null, imageUrl?: string | null, imageAlt?: string | null, descriptionHead?: string | null, url?: string | null, tag?: string | null } | null> | null, gallery?: Array<{ __typename?: 'GalleryItemNode', imageUrl?: string | null, imageAlt?: string | null } | null> | null } | null };

export type MagazineEvidenzaQueryVariables = Exact<{ [key: string]: never; }>;


export type MagazineEvidenzaQuery = { __typename?: 'Query', magazineEvidenza?: Array<{ __typename?: 'MagazineNode', pk?: number | null, title?: string | null, url?: string | null, imageUrl?: string | null, imageAlt?: string | null, subtitle?: string | null, description?: string | null, premio?: string | null, tag?: string | null } | null> | null };

export type AllMagazineQueryVariables = Exact<{ [key: string]: never; }>;


export type AllMagazineQuery = { __typename?: 'Query', allMagazine?: Array<{ __typename?: 'MagazineNode', pk?: number | null, title?: string | null, slug?: string | null, url?: string | null, imageUrl?: string | null, imageAlt?: string | null, premio?: string | null, tag?: string | null } | null> | null };

export type MagazineHomepageQueryVariables = Exact<{ [key: string]: never; }>;


export type MagazineHomepageQuery = { __typename?: 'Query', magazineHomepage?: Array<{ __typename?: 'MagazineNode', pk?: number | null, title?: string | null, url?: string | null, imageUrl?: string | null, imageAlt?: string | null, subtitle?: string | null, description?: string | null, premio?: string | null, tag?: string | null } | null> | null };

export type AllCategorieMagazineQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCategorieMagazineQuery = { __typename?: 'Query', allCategorieMagazine?: Array<{ __typename?: 'CategoriaMagazineNode', pk?: number | null, title?: string | null, slug?: string | null } | null> | null };

export type PagebuilderPlaceholderNodeFragmentFragment = { __typename?: 'PagebuilderPlaceholderNode', key: string, text?: string | null, json_draft?: string | null, json_published?: string | null };

export type SimplePaginaNodeFragmentFragment = { __typename?: 'PaginaNode', pk?: number | null, chiave?: string | null, titolo: string, nome?: string | null, descrizione?: string | null, slug?: string | null, url?: string | null, previewImage?: string | null, mainImage?: string | null, hreflangs?: Array<{ __typename?: 'HrefLangType', hrefLang?: string | null, href?: string | null, locale?: string | null } | null> | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null } | null };

export type PaginaNodeFragmentFragment = { __typename?: 'PaginaNode', pk?: number | null, model?: number | null, modelClass?: string | null, titolo: string, nome?: string | null, descrizione?: string | null, chiave?: string | null, url?: string | null, slug?: string | null, template?: string | null, adminUrl?: string | null, visibile?: boolean | null, pubblicato?: boolean | null, visibilitaDal?: string | null, visibilitaAl?: string | null, imageAlt?: string | null, previewImage?: string | null, mainImage?: string | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null } | null, hreflangs?: Array<{ __typename?: 'HrefLangType', hrefLang?: string | null, href?: string | null, locale?: string | null } | null> | null, children?: Array<{ __typename?: 'PaginaNode', pk?: number | null, chiave?: string | null, titolo: string, nome?: string | null, descrizione?: string | null, slug?: string | null, url?: string | null, previewImage?: string | null, mainImage?: string | null, hreflangs?: Array<{ __typename?: 'HrefLangType', hrefLang?: string | null, href?: string | null, locale?: string | null } | null> | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null } | null } | null> | null, menuChildren?: Array<{ __typename?: 'PaginaNode', pk?: number | null, chiave?: string | null, titolo: string, nome?: string | null, descrizione?: string | null, slug?: string | null, url?: string | null, previewImage?: string | null, mainImage?: string | null, hreflangs?: Array<{ __typename?: 'HrefLangType', hrefLang?: string | null, href?: string | null, locale?: string | null } | null> | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null } | null } | null> | null, pagebuilders?: Array<{ __typename?: 'PagebuilderPlaceholderNode', key: string, text?: string | null, json_draft?: string | null, json_published?: string | null } | null> | null };

export type PaginaQueryVariables = Exact<{
  chiave?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  contentTypeId?: InputMaybe<Scalars['Int']>;
  objectId?: InputMaybe<Scalars['Int']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  withMenuChildren?: InputMaybe<Scalars['Boolean']>;
}>;


export type PaginaQuery = { __typename?: 'Query', pagina?: { __typename?: 'PaginaNode', pk?: number | null, model?: number | null, modelClass?: string | null, titolo: string, nome?: string | null, descrizione?: string | null, chiave?: string | null, url?: string | null, slug?: string | null, template?: string | null, adminUrl?: string | null, visibile?: boolean | null, pubblicato?: boolean | null, visibilitaDal?: string | null, visibilitaAl?: string | null, imageAlt?: string | null, previewImage?: string | null, mainImage?: string | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null } | null, hreflangs?: Array<{ __typename?: 'HrefLangType', hrefLang?: string | null, href?: string | null, locale?: string | null } | null> | null, children?: Array<{ __typename?: 'PaginaNode', pk?: number | null, chiave?: string | null, titolo: string, nome?: string | null, descrizione?: string | null, slug?: string | null, url?: string | null, previewImage?: string | null, mainImage?: string | null, hreflangs?: Array<{ __typename?: 'HrefLangType', hrefLang?: string | null, href?: string | null, locale?: string | null } | null> | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null } | null } | null> | null, menuChildren?: Array<{ __typename?: 'PaginaNode', pk?: number | null, chiave?: string | null, titolo: string, nome?: string | null, descrizione?: string | null, slug?: string | null, url?: string | null, previewImage?: string | null, mainImage?: string | null, hreflangs?: Array<{ __typename?: 'HrefLangType', hrefLang?: string | null, href?: string | null, locale?: string | null } | null> | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null } | null } | null> | null, pagebuilders?: Array<{ __typename?: 'PagebuilderPlaceholderNode', key: string, text?: string | null, json_draft?: string | null, json_published?: string | null } | null> | null } | null };

export type PagineCatchAllQueryVariables = Exact<{ [key: string]: never; }>;


export type PagineCatchAllQuery = { __typename?: 'Query', pagine?: { __typename?: 'PaginaNodeConnection', edges: Array<{ __typename?: 'PaginaNodeEdge', node?: { __typename?: 'PaginaNode', path?: string | null } | null } | null> } | null };

export type ProgettoQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type ProgettoQuery = { __typename?: 'Query', progetto?: { __typename?: 'ProgettiNode', pk?: number | null, slug?: string | null, modelPk?: number | null, title?: string | null, premio?: string | null, imageUrl?: string | null, description?: string | null, sottotitolo?: string | null, descriptionFooter?: string | null, url?: string | null, imageAlt?: string | null, destinazioni?: Array<{ __typename?: 'DestinazioneUsoNode', id?: string | null, titolo?: string | null, slug?: string | null } | null> | null, collezioni?: Array<{ __typename?: 'CollezioneNode', id: number, url?: string | null, nome?: string | null, listingImage?: { __typename?: 'ImmaginiCollezioniNode', url?: string | null, imageAlt?: string | null } | null } | null> | null, correlati?: Array<{ __typename?: 'ProgettiNode', title?: string | null, premio?: string | null, imageUrl?: string | null, url?: string | null, destinazioni?: Array<{ __typename?: 'DestinazioneUsoNode', id?: string | null, titolo?: string | null, slug?: string | null } | null> | null } | null> | null, infoProgettiCollezione?: Array<{ __typename?: 'InfoProgettoCollezioneObject', collezione?: { __typename?: 'CollezioneNode', nome?: string | null, url?: string | null, slug: string, brand?: { __typename?: 'BrandNode', nome?: string | null, slug: string } | null, categoriaEffetto?: { __typename?: 'CategoriaNode', slug: string } | null } | null, infoProgetti?: Array<{ __typename?: 'InfoProgettoNode', id: number, coloreNome?: string | null, finituraNome?: string | null, tonalitaUrl?: string | null, spessore?: string | null, formato?: { __typename?: 'FormatiNode', nome?: string | null, lato1Cm?: string | null, lato2Cm?: string | null } | null, superficie?: { __typename?: 'SuperficiObject', nome?: string | null } | null } | null> | null } | null> | null, galleryProgettoDetail?: Array<{ __typename?: 'ImmaginiProgettiNode', id?: number | null, url?: string | null, imageAlt?: string | null } | null> | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null } | null };

export type ProgettiQueryVariables = Exact<{ [key: string]: never; }>;


export type ProgettiQuery = { __typename?: 'Query', progetti?: Array<{ __typename?: 'ProgettiNode', title?: string | null, premio?: string | null, imageAlt?: string | null, imageUrl?: string | null, description?: string | null, url?: string | null, slug?: string | null, tag?: string | null } | null> | null };

export type ProgettiEvidenzaQueryVariables = Exact<{ [key: string]: never; }>;


export type ProgettiEvidenzaQuery = { __typename?: 'Query', progettiEvidenza?: Array<{ __typename?: 'ProgettiNode', title?: string | null, premio?: string | null, imageUrl?: string | null, imageAlt?: string | null, description?: string | null, url?: string | null, tag?: string | null } | null> | null };

export type CategorieProgettiQueryVariables = Exact<{ [key: string]: never; }>;


export type CategorieProgettiQuery = { __typename?: 'Query', categorieProgetti?: Array<{ __typename?: 'SottoCategorieNode', id: number, title?: string | null } | null> | null };

export type RivenditoriQueryVariables = Exact<{
  regione?: InputMaybe<Scalars['String']>;
  provincia?: InputMaybe<Scalars['String']>;
  citta?: InputMaybe<Scalars['String']>;
}>;


export type RivenditoriQuery = { __typename?: 'Query', rivenditori?: Array<{ __typename?: 'ClienteNode', pk?: number | null, nome: string, email?: string | null, mobile?: string | null, rivenditoreWeb: boolean, promozionaleWeb: boolean, citta?: string | null, cap?: string | null, indirizzo?: string | null, provincia?: string | null, regione?: string | null, nazione?: string | null, regioneSlug?: string | null, provinciaSlug?: string | null, cittaSlug?: string | null, latitudine?: string | null, longitudine?: string | null, telefono?: string | null } | null> | null };

export type RegioniQueryVariables = Exact<{ [key: string]: never; }>;


export type RegioniQuery = { __typename?: 'Query', regioni?: Array<{ __typename?: 'LocalitaNode', pk?: number | null, name?: string | null, slug?: string | null, tipo?: string | null } | null> | null };

export type RegioneQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type RegioneQuery = { __typename?: 'Query', regione?: { __typename?: 'LocalitaNode', pk?: number | null, name?: string | null, slug?: string | null, tipo?: string | null } | null };

export type ProvinceQueryVariables = Exact<{
  regione: Scalars['String'];
}>;


export type ProvinceQuery = { __typename?: 'Query', province?: Array<{ __typename?: 'LocalitaNode', pk?: number | null, name?: string | null, slug?: string | null, tipo?: string | null } | null> | null };

export type ProvinciaQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ProvinciaQuery = { __typename?: 'Query', provincia?: { __typename?: 'LocalitaNode', pk?: number | null, name?: string | null, slug?: string | null, tipo?: string | null, clienteRef?: { __typename?: 'ClienteNode', regioneDummy?: string | null, regioneSlug?: string | null } | null } | null };

export type CittaQueryVariables = Exact<{
  provincia: Scalars['String'];
}>;


export type CittaQuery = { __typename?: 'Query', citta?: Array<{ __typename?: 'LocalitaNode', pk?: number | null, name?: string | null, slug?: string | null, tipo?: string | null } | null> | null };

export type CittaSingolareQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type CittaSingolareQuery = { __typename?: 'Query', cittaSingolare?: { __typename?: 'LocalitaNode', pk?: number | null, name?: string | null, slug?: string | null, tipo?: string | null, clienteRef?: { __typename?: 'ClienteNode', regioneDummy?: string | null, regioneSlug?: string | null, provinciaDummy?: string | null, provinciaSlug?: string | null } | null } | null };

export type RivenditoreQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type RivenditoreQuery = { __typename?: 'Query', rivenditore?: { __typename?: 'ClienteNode', pk?: number | null, nome: string, email?: string | null, mobile?: string | null, indirizzo?: string | null, citta?: string | null, cap?: string | null, provincia?: string | null, regione?: string | null, nazione?: string | null, telefono?: string | null } | null };

export type ProfessioniQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfessioniQuery = { __typename?: 'Query', professioni?: Array<{ __typename?: 'ProfessioniObject', title?: string | null, codice?: string | null } | null> | null };

export type CreateContattoRivenditoreMutationVariables = Exact<{
  input: ContattoRivenditoreInput;
}>;


export type CreateContattoRivenditoreMutation = { __typename?: 'Mutation', createContattoRivenditore?: { __typename?: 'CreateContattoRivenditore', status?: boolean | null } | null };

export type SoluzioneQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type SoluzioneQuery = { __typename?: 'Query', soluzione?: { __typename?: 'SoluzioneNode', pk?: number | null, title: string, adminUrl?: string | null, visibile?: boolean | null, model?: number | null, modelClass?: string | null, pubblicato?: boolean | null, visibilitaDal?: string | null, visibilitaAl?: string | null, imageAlt?: string | null, image?: string | null, subtitle?: string | null, slug: string, destinazioniUso?: Array<{ __typename?: 'DestinazioneSoluzioneNode', pk?: number | null, title?: string | null, image?: string | null } | null> | null, correlati?: Array<{ __typename?: 'SoluzioneNode', pk?: number | null, title: string, subtitle?: string | null, image?: string | null, imageAlt?: string | null, url?: string | null } | null> | null, categorie?: Array<{ __typename?: 'CategoriaNode', pk?: number | null, title: string, url?: string | null, mainImage?: string | null } | null> | null, pagina?: { __typename?: 'PaginaNode', pk?: number | null, chiave?: string | null, titolo: string, nome?: string | null, descrizione?: string | null, slug?: string | null, url?: string | null, previewImage?: string | null, mainImage?: string | null, hreflangs?: Array<{ __typename?: 'HrefLangType', hrefLang?: string | null, href?: string | null, locale?: string | null } | null> | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null } | null } | null, pagebuilders?: Array<{ __typename?: 'PagebuilderPlaceholderNode', key: string, text?: string | null, json_draft?: string | null, json_published?: string | null } | null> | null } | null };

export type SoluzioniQueryVariables = Exact<{ [key: string]: never; }>;


export type SoluzioniQuery = { __typename?: 'Query', soluzioni?: Array<{ __typename?: 'SoluzioneNode', pk?: number | null, url?: string | null, imageAlt?: string | null, slug: string, title: string, image?: string | null } | null> | null };

export type SostenibilitaCodiceEticoQueryVariables = Exact<{ [key: string]: never; }>;


export type SostenibilitaCodiceEticoQuery = { __typename?: 'Query', sostenibilitaCodiceEtico?: Array<{ __typename?: 'DocumentiBrandNode', id?: number | null, nome?: string | null, url?: string | null, dataIns?: any | null, dataUltMod?: any | null, tipologie?: { __typename?: 'TipologieNode', nome?: string | null, codice?: string | null } | null } | null> | null };

export type SostenibilitaPoliticaAziendaleQueryVariables = Exact<{ [key: string]: never; }>;


export type SostenibilitaPoliticaAziendaleQuery = { __typename?: 'Query', sostenibilitaPoliticaAziendale?: Array<{ __typename?: 'DocumentiBrandNode', id?: number | null, nome?: string | null, url?: string | null, dataIns?: any | null, dataUltMod?: any | null, tipologie?: { __typename?: 'TipologieNode', nome?: string | null, codice?: string | null } | null } | null> | null };

export type TecnologiaQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type TecnologiaQuery = { __typename?: 'Query', tecnologia?: { __typename?: 'TecnologiaNode', pk?: number | null, adminUrl?: string | null, visibile?: boolean | null, model?: number | null, modelClass?: string | null, pubblicato?: boolean | null, visibilitaDal?: string | null, visibilitaAl?: string | null, subtitle?: string | null, title?: string | null, name?: string | null, imageAlt?: string | null, listingImage?: string | null, image?: string | null, correlati?: Array<{ __typename?: 'TecnologiaNode', pk?: number | null, title?: string | null, subtitle?: string | null, name?: string | null, listingImage?: string | null, url?: string | null, imageAlt?: string | null, image?: string | null } | null> | null, pagina?: { __typename?: 'PaginaNode', pk?: number | null, chiave?: string | null, titolo: string, nome?: string | null, descrizione?: string | null, slug?: string | null, url?: string | null, previewImage?: string | null, mainImage?: string | null, hreflangs?: Array<{ __typename?: 'HrefLangType', hrefLang?: string | null, href?: string | null, locale?: string | null } | null> | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null } | null } | null, pagebuilders?: Array<{ __typename?: 'PagebuilderPlaceholderNode', key: string, text?: string | null, json_draft?: string | null, json_published?: string | null } | null> | null } | null };

export type TecnologieQueryVariables = Exact<{ [key: string]: never; }>;


export type TecnologieQuery = { __typename?: 'Query', tecnologie?: Array<{ __typename?: 'TecnologiaNode', pk?: number | null, subtitle?: string | null, title?: string | null, name?: string | null, listingImage?: string | null, url?: string | null, slug: string, image?: string | null, imageAlt?: string | null } | null> | null };

export type TonalitaQueryVariables = Exact<{
  brand: Scalars['String'];
  collezione: Scalars['String'];
  slug: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type TonalitaQuery = { __typename?: 'Query', tonalita?: { __typename?: 'TonalitaDetailObject', brand?: { __typename?: 'BrandNode', id: string, nome?: string | null, title?: string | null, slug: string } | null, imageCollezione?: { __typename?: 'ImmaginiCollezioniNode', id?: number | null, url?: string | null } | null, collezione?: { __typename?: 'CollezioneNode', title: string, sottotitolo?: string | null, slug: string, url?: string | null, shield?: boolean | null, gallery?: Array<{ __typename?: 'ImmaginiCollezioniNode', id?: number | null, url?: string | null } | null> | null, shadeVariations?: Array<{ __typename?: 'ShadeVariationNode', codice?: string | null, nome?: string | null, imageUrl?: string | null } | null> | null, destinazioni?: Array<{ __typename?: 'DestinazioneNode', nome?: string | null, titolo?: string | null, imageUrl?: string | null } | null> | null } | null, tonalitaCollezione?: { __typename?: 'TonalitaCollezioneNode', id: string, pk?: number | null, modelPk?: number | null, tonalitaNome?: string | null, url?: string | null, articolo?: { __typename?: 'ArticoliNode', image?: string | null } | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, superficiSpessoriFormati?: Array<{ __typename?: 'SuperficiObject', nome?: string | null, dcof?: string | null, bcra?: string | null, pendoloAS4586?: string | null, pendoloBS7976?: string | null, pendoloUNE41901?: string | null, scivolositaNome?: string | null, scivolositaLabel?: string | null, specificheAbcNome?: string | null, specificheAbcLabel?: string | null, spessori?: Array<{ __typename?: 'SpessoriFormatiObject', spessore?: string | null, codice?: string | null, formati?: Array<{ __typename?: 'FormatiSpessoriObject', nome?: string | null, lato1Intero?: string | null, lato2Intero?: string | null, lato1Numeratore?: string | null, lato2Numeratore?: string | null, lato1Denominatore?: string | null, lato2Denominatore?: string | null } | null> | null } | null> | null } | null> | null, certificazioni?: Array<{ __typename?: 'CaratteristicheNode', pk?: number | null, title?: string | null, url?: string | null, logo?: string | null, ambientale?: boolean | null } | null> | null, gallery?: Array<{ __typename?: 'ImmaginiCollezioniNode', id?: number | null, url?: string | null } | null> | null } | null } | null };

export type AllTonalitaQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTonalitaQuery = { __typename?: 'Query', allTonalita?: Array<{ __typename?: 'TonalitaCollezioneNode', slug?: string | null, slugCollezione?: string | null, slugBrand?: string | null } | null> | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UtenteNode', pk?: number | null, email: string, nome?: string | null, cognome?: string | null, isStaff: boolean, edit?: boolean | null, showToolbar?: boolean | null } | null };

export const SimplePaginaNodeFragmentFragmentDoc = gql`
    fragment SimplePaginaNodeFragment on PaginaNode {
  pk
  chiave
  titolo
  nome
  descrizione
  slug
  url
  previewImage
  mainImage
  hreflangs {
    hrefLang
    href
    locale
  }
  breadcrumbs {
    label
    url
  }
  seo {
    title
    description
    image
    noindex
  }
}
    `;
export const PagebuilderPlaceholderNodeFragmentFragmentDoc = gql`
    fragment PagebuilderPlaceholderNodeFragment on PagebuilderPlaceholderNode {
  key
  json_draft: jsonDraft
  json_published: jsonPublished
  text
}
    `;
export const PaginaNodeFragmentFragmentDoc = gql`
    fragment PaginaNodeFragment on PaginaNode {
  pk
  model
  modelClass
  titolo
  nome
  descrizione
  chiave
  url
  slug
  template
  adminUrl
  visibile
  pubblicato
  visibilitaDal
  visibilitaAl
  imageAlt
  previewImage
  mainImage
  breadcrumbs {
    label
    url
  }
  seo {
    title
    description
    image
    noindex
  }
  hreflangs {
    hrefLang
    href
    locale
  }
  children {
    ...SimplePaginaNodeFragment
  }
  menuChildren {
    ...SimplePaginaNodeFragment
  }
  pagebuilders {
    ...PagebuilderPlaceholderNodeFragment
  }
}
    ${SimplePaginaNodeFragmentFragmentDoc}
${PagebuilderPlaceholderNodeFragmentFragmentDoc}`;
export const AreaDownloadCataloghiCollezioniDocument = gql`
    query AreaDownloadCataloghiCollezioni {
  areaDownloadCataloghiCollezioni {
    id
    nomeWeb
    url
    brand {
      pk
      title
      url
    }
  }
}
    `;

/**
 * __useAreaDownloadCataloghiCollezioniQuery__
 *
 * To run a query within a React component, call `useAreaDownloadCataloghiCollezioniQuery` and pass it any options that fit your needs.
 * When your component renders, `useAreaDownloadCataloghiCollezioniQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAreaDownloadCataloghiCollezioniQuery({
 *   variables: {
 *   },
 * });
 */
export function useAreaDownloadCataloghiCollezioniQuery(baseOptions?: Apollo.QueryHookOptions<AreaDownloadCataloghiCollezioniQuery, AreaDownloadCataloghiCollezioniQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AreaDownloadCataloghiCollezioniQuery, AreaDownloadCataloghiCollezioniQueryVariables>(AreaDownloadCataloghiCollezioniDocument, options);
      }
export function useAreaDownloadCataloghiCollezioniLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AreaDownloadCataloghiCollezioniQuery, AreaDownloadCataloghiCollezioniQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AreaDownloadCataloghiCollezioniQuery, AreaDownloadCataloghiCollezioniQueryVariables>(AreaDownloadCataloghiCollezioniDocument, options);
        }
export type AreaDownloadCataloghiCollezioniQueryHookResult = ReturnType<typeof useAreaDownloadCataloghiCollezioniQuery>;
export type AreaDownloadCataloghiCollezioniLazyQueryHookResult = ReturnType<typeof useAreaDownloadCataloghiCollezioniLazyQuery>;
export type AreaDownloadCataloghiCollezioniQueryResult = Apollo.QueryResult<AreaDownloadCataloghiCollezioniQuery, AreaDownloadCataloghiCollezioniQueryVariables>;
export const AreaDownloadCataloghiGeneraliDocument = gql`
    query AreaDownloadCataloghiGenerali {
  areaDownloadCataloghiGenerali {
    id
    nome
    url
    brand {
      pk
      title
      slug
    }
    tipologie {
      nome
      codice
    }
    dataIns
    dataUltMod
  }
}
    `;

/**
 * __useAreaDownloadCataloghiGeneraliQuery__
 *
 * To run a query within a React component, call `useAreaDownloadCataloghiGeneraliQuery` and pass it any options that fit your needs.
 * When your component renders, `useAreaDownloadCataloghiGeneraliQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAreaDownloadCataloghiGeneraliQuery({
 *   variables: {
 *   },
 * });
 */
export function useAreaDownloadCataloghiGeneraliQuery(baseOptions?: Apollo.QueryHookOptions<AreaDownloadCataloghiGeneraliQuery, AreaDownloadCataloghiGeneraliQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AreaDownloadCataloghiGeneraliQuery, AreaDownloadCataloghiGeneraliQueryVariables>(AreaDownloadCataloghiGeneraliDocument, options);
      }
export function useAreaDownloadCataloghiGeneraliLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AreaDownloadCataloghiGeneraliQuery, AreaDownloadCataloghiGeneraliQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AreaDownloadCataloghiGeneraliQuery, AreaDownloadCataloghiGeneraliQueryVariables>(AreaDownloadCataloghiGeneraliDocument, options);
        }
export type AreaDownloadCataloghiGeneraliQueryHookResult = ReturnType<typeof useAreaDownloadCataloghiGeneraliQuery>;
export type AreaDownloadCataloghiGeneraliLazyQueryHookResult = ReturnType<typeof useAreaDownloadCataloghiGeneraliLazyQuery>;
export type AreaDownloadCataloghiGeneraliQueryResult = Apollo.QueryResult<AreaDownloadCataloghiGeneraliQuery, AreaDownloadCataloghiGeneraliQueryVariables>;
export const AreaDownloadAziendaDocument = gql`
    query AreaDownloadAzienda {
  areaDownloadAzienda {
    id
    nome
    url
    tipologie {
      nome
      codice
    }
    dataIns
    dataUltMod
  }
}
    `;

/**
 * __useAreaDownloadAziendaQuery__
 *
 * To run a query within a React component, call `useAreaDownloadAziendaQuery` and pass it any options that fit your needs.
 * When your component renders, `useAreaDownloadAziendaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAreaDownloadAziendaQuery({
 *   variables: {
 *   },
 * });
 */
export function useAreaDownloadAziendaQuery(baseOptions?: Apollo.QueryHookOptions<AreaDownloadAziendaQuery, AreaDownloadAziendaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AreaDownloadAziendaQuery, AreaDownloadAziendaQueryVariables>(AreaDownloadAziendaDocument, options);
      }
export function useAreaDownloadAziendaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AreaDownloadAziendaQuery, AreaDownloadAziendaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AreaDownloadAziendaQuery, AreaDownloadAziendaQueryVariables>(AreaDownloadAziendaDocument, options);
        }
export type AreaDownloadAziendaQueryHookResult = ReturnType<typeof useAreaDownloadAziendaQuery>;
export type AreaDownloadAziendaLazyQueryHookResult = ReturnType<typeof useAreaDownloadAziendaLazyQuery>;
export type AreaDownloadAziendaQueryResult = Apollo.QueryResult<AreaDownloadAziendaQuery, AreaDownloadAziendaQueryVariables>;
export const AudioDescrizioneDocument = gql`
    query AudioDescrizione($slug: String!) {
  audioDescrizione(slug: $slug) {
    pk
    model
    title
    titolo
    slug
    collezione {
      pk
      title
      slug
    }
    audioFiles {
      pk
      cta
      fileUrl
    }
  }
}
    `;

/**
 * __useAudioDescrizioneQuery__
 *
 * To run a query within a React component, call `useAudioDescrizioneQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudioDescrizioneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudioDescrizioneQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useAudioDescrizioneQuery(baseOptions: Apollo.QueryHookOptions<AudioDescrizioneQuery, AudioDescrizioneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudioDescrizioneQuery, AudioDescrizioneQueryVariables>(AudioDescrizioneDocument, options);
      }
export function useAudioDescrizioneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudioDescrizioneQuery, AudioDescrizioneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudioDescrizioneQuery, AudioDescrizioneQueryVariables>(AudioDescrizioneDocument, options);
        }
export type AudioDescrizioneQueryHookResult = ReturnType<typeof useAudioDescrizioneQuery>;
export type AudioDescrizioneLazyQueryHookResult = ReturnType<typeof useAudioDescrizioneLazyQuery>;
export type AudioDescrizioneQueryResult = Apollo.QueryResult<AudioDescrizioneQuery, AudioDescrizioneQueryVariables>;
export const BrandDocument = gql`
    query Brand($slug: String!) {
  brand(slug: $slug) {
    pk
    adminUrl
    visibile
    model
    modelClass
    pubblicato
    visibilitaDal
    visibilitaAl
    nome
    title
    slug
    description
    immagineStatica
    immagineHome
    logoTransparent
    listingTitoloSeoH1
    listingTestoSeo
    correlati {
      pk
      nome
      logo
      immagineStatica
      immagineHome
      logoTransparent
      url
      slug
    }
    collezioni {
      pk
      nome
      title
      slug
      url
      categoriaEffetto {
        slug
      }
      brand {
        nome
        slug
      }
      listingImage {
        url
        imageAlt
      }
    }
    progetti {
      name
      url
      title
      imageUrl
    }
    magazines {
      pk
      title
      url
      description
      subtitle
      imageUrl
      tag: categoriaTitle
    }
    breadcrumbs {
      label
      url
    }
    pagina {
      ...SimplePaginaNodeFragment
    }
    pagebuilders {
      ...PagebuilderPlaceholderNodeFragment
    }
  }
}
    ${SimplePaginaNodeFragmentFragmentDoc}
${PagebuilderPlaceholderNodeFragmentFragmentDoc}`;

/**
 * __useBrandQuery__
 *
 * To run a query within a React component, call `useBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useBrandQuery(baseOptions: Apollo.QueryHookOptions<BrandQuery, BrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandQuery, BrandQueryVariables>(BrandDocument, options);
      }
export function useBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandQuery, BrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandQuery, BrandQueryVariables>(BrandDocument, options);
        }
export type BrandQueryHookResult = ReturnType<typeof useBrandQuery>;
export type BrandLazyQueryHookResult = ReturnType<typeof useBrandLazyQuery>;
export type BrandQueryResult = Apollo.QueryResult<BrandQuery, BrandQueryVariables>;
export const BrandsDocument = gql`
    query Brands {
  brands {
    pk
    nome
    slug
    path
    logo
    url
    immagineHome
    logoTransparent
  }
}
    `;

/**
 * __useBrandsQuery__
 *
 * To run a query within a React component, call `useBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrandsQuery(baseOptions?: Apollo.QueryHookOptions<BrandsQuery, BrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandsQuery, BrandsQueryVariables>(BrandsDocument, options);
      }
export function useBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandsQuery, BrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandsQuery, BrandsQueryVariables>(BrandsDocument, options);
        }
export type BrandsQueryHookResult = ReturnType<typeof useBrandsQuery>;
export type BrandsLazyQueryHookResult = ReturnType<typeof useBrandsLazyQuery>;
export type BrandsQueryResult = Apollo.QueryResult<BrandsQuery, BrandsQueryVariables>;
export const AllCaratteristicheDocument = gql`
    query AllCaratteristiche {
  allCaratteristiche {
    id
    title
    descrizione
    url
    logo
    children {
      pk
      title
      url
      logo
      ambientale
    }
  }
}
    `;

/**
 * __useAllCaratteristicheQuery__
 *
 * To run a query within a React component, call `useAllCaratteristicheQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCaratteristicheQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCaratteristicheQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCaratteristicheQuery(baseOptions?: Apollo.QueryHookOptions<AllCaratteristicheQuery, AllCaratteristicheQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCaratteristicheQuery, AllCaratteristicheQueryVariables>(AllCaratteristicheDocument, options);
      }
export function useAllCaratteristicheLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCaratteristicheQuery, AllCaratteristicheQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCaratteristicheQuery, AllCaratteristicheQueryVariables>(AllCaratteristicheDocument, options);
        }
export type AllCaratteristicheQueryHookResult = ReturnType<typeof useAllCaratteristicheQuery>;
export type AllCaratteristicheLazyQueryHookResult = ReturnType<typeof useAllCaratteristicheLazyQuery>;
export type AllCaratteristicheQueryResult = Apollo.QueryResult<AllCaratteristicheQuery, AllCaratteristicheQueryVariables>;
export const CategoriaDocument = gql`
    query Categoria($slug1: String, $slug2: String) {
  categoria(slug1: $slug1, slug2: $slug2) {
    pk
    modelPk
    nome
    slug
    title
    titleDescription
    description
    abstract
    voceMenu
    titleTerzoLivello
    descriptionTerzoLivello
    objectId
    macrocategoria {
      chiaveRicerca
    }
  }
}
    `;

/**
 * __useCategoriaQuery__
 *
 * To run a query within a React component, call `useCategoriaQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriaQuery({
 *   variables: {
 *      slug1: // value for 'slug1'
 *      slug2: // value for 'slug2'
 *   },
 * });
 */
export function useCategoriaQuery(baseOptions?: Apollo.QueryHookOptions<CategoriaQuery, CategoriaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriaQuery, CategoriaQueryVariables>(CategoriaDocument, options);
      }
export function useCategoriaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriaQuery, CategoriaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriaQuery, CategoriaQueryVariables>(CategoriaDocument, options);
        }
export type CategoriaQueryHookResult = ReturnType<typeof useCategoriaQuery>;
export type CategoriaLazyQueryHookResult = ReturnType<typeof useCategoriaLazyQuery>;
export type CategoriaQueryResult = Apollo.QueryResult<CategoriaQuery, CategoriaQueryVariables>;
export const EffettiPerCategoriaDocument = gql`
    query EffettiPerCategoria($categoriaId: Int) {
  effettiPerCategoria(categoriaId: $categoriaId) {
    pk
    title
    slug
    categoriaTitle
    description
    imageUrl
    imageAlt
    url
  }
}
    `;

/**
 * __useEffettiPerCategoriaQuery__
 *
 * To run a query within a React component, call `useEffettiPerCategoriaQuery` and pass it any options that fit your needs.
 * When your component renders, `useEffettiPerCategoriaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEffettiPerCategoriaQuery({
 *   variables: {
 *      categoriaId: // value for 'categoriaId'
 *   },
 * });
 */
export function useEffettiPerCategoriaQuery(baseOptions?: Apollo.QueryHookOptions<EffettiPerCategoriaQuery, EffettiPerCategoriaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EffettiPerCategoriaQuery, EffettiPerCategoriaQueryVariables>(EffettiPerCategoriaDocument, options);
      }
export function useEffettiPerCategoriaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EffettiPerCategoriaQuery, EffettiPerCategoriaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EffettiPerCategoriaQuery, EffettiPerCategoriaQueryVariables>(EffettiPerCategoriaDocument, options);
        }
export type EffettiPerCategoriaQueryHookResult = ReturnType<typeof useEffettiPerCategoriaQuery>;
export type EffettiPerCategoriaLazyQueryHookResult = ReturnType<typeof useEffettiPerCategoriaLazyQuery>;
export type EffettiPerCategoriaQueryResult = Apollo.QueryResult<EffettiPerCategoriaQuery, EffettiPerCategoriaQueryVariables>;
export const CollezioniDocument = gql`
    query Collezioni {
  collezioni {
    pk
    nome
    description
    slug
    title
    brand {
      slug
    }
  }
}
    `;

/**
 * __useCollezioniQuery__
 *
 * To run a query within a React component, call `useCollezioniQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollezioniQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollezioniQuery({
 *   variables: {
 *   },
 * });
 */
export function useCollezioniQuery(baseOptions?: Apollo.QueryHookOptions<CollezioniQuery, CollezioniQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollezioniQuery, CollezioniQueryVariables>(CollezioniDocument, options);
      }
export function useCollezioniLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollezioniQuery, CollezioniQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollezioniQuery, CollezioniQueryVariables>(CollezioniDocument, options);
        }
export type CollezioniQueryHookResult = ReturnType<typeof useCollezioniQuery>;
export type CollezioniLazyQueryHookResult = ReturnType<typeof useCollezioniLazyQuery>;
export type CollezioniQueryResult = Apollo.QueryResult<CollezioniQuery, CollezioniQueryVariables>;
export const UltimeCollezioniDocument = gql`
    query UltimeCollezioni {
  ultimeCollezioni {
    pk
    title
    url
    slug
    categoriaEffetto {
      slug
    }
    brand {
      nome
      slug
    }
    listingImage {
      url
      imageAlt
    }
  }
}
    `;

/**
 * __useUltimeCollezioniQuery__
 *
 * To run a query within a React component, call `useUltimeCollezioniQuery` and pass it any options that fit your needs.
 * When your component renders, `useUltimeCollezioniQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUltimeCollezioniQuery({
 *   variables: {
 *   },
 * });
 */
export function useUltimeCollezioniQuery(baseOptions?: Apollo.QueryHookOptions<UltimeCollezioniQuery, UltimeCollezioniQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UltimeCollezioniQuery, UltimeCollezioniQueryVariables>(UltimeCollezioniDocument, options);
      }
export function useUltimeCollezioniLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UltimeCollezioniQuery, UltimeCollezioniQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UltimeCollezioniQuery, UltimeCollezioniQueryVariables>(UltimeCollezioniDocument, options);
        }
export type UltimeCollezioniQueryHookResult = ReturnType<typeof useUltimeCollezioniQuery>;
export type UltimeCollezioniLazyQueryHookResult = ReturnType<typeof useUltimeCollezioniLazyQuery>;
export type UltimeCollezioniQueryResult = Apollo.QueryResult<UltimeCollezioniQuery, UltimeCollezioniQueryVariables>;
export const EffettiDocument = gql`
    query Effetti {
  effetti {
    title
    mainImage
    imageAlt
    url
  }
}
    `;

/**
 * __useEffettiQuery__
 *
 * To run a query within a React component, call `useEffettiQuery` and pass it any options that fit your needs.
 * When your component renders, `useEffettiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEffettiQuery({
 *   variables: {
 *   },
 * });
 */
export function useEffettiQuery(baseOptions?: Apollo.QueryHookOptions<EffettiQuery, EffettiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EffettiQuery, EffettiQueryVariables>(EffettiDocument, options);
      }
export function useEffettiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EffettiQuery, EffettiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EffettiQuery, EffettiQueryVariables>(EffettiDocument, options);
        }
export type EffettiQueryHookResult = ReturnType<typeof useEffettiQuery>;
export type EffettiLazyQueryHookResult = ReturnType<typeof useEffettiLazyQuery>;
export type EffettiQueryResult = Apollo.QueryResult<EffettiQuery, EffettiQueryVariables>;
export const CollezioneDocument = gql`
    query Collezione($slug: String!, $brand: String!, $preview: Boolean) {
  collezione(slug: $slug, brand: $brand, preview: $preview) {
    pk
    modelPk
    nome
    title
    sottotitolo
    description
    slug
    brand {
      id
      nome
      title
      slug
    }
    quickship
    shield
    silktech
    novita
    nsf
    nsfMagazineSlug
    isUsa
    claim
    payoff
    logo
    url
    gallery {
      id
      url
      imageAlt
      articoliGallery {
        pk
        image
        imageAlt
        tonalitaNome
        tonalitaUrl
        finituraNome
      }
    }
    abaco {
      id
      url
    }
    video
    linkVideo
    immagineVideo {
      id
      url
    }
    spessoriFormati {
      spessore
      formati {
        nome
        lato1Intero
        lato2Intero
        lato1Numeratore
        lato2Numeratore
        lato1Denominatore
        lato2Denominatore
      }
    }
    colori {
      id
      nome
      tonalita {
        nome
        url
        image {
          title
          alt
          url
        }
      }
    }
    superfici {
      id
      nome
      dcof
      bcra
      pendoloAS4586
      pendoloBS7976
      pendoloUNE41901
      scivolositaNome
      scivolositaLabel
      specificheAbcNome
      specificheAbcLabel
    }
    shadeVariations {
      codice
      nome
      imageUrl
    }
    destinazioni {
      nome
      titolo
      imageUrl
      imageAlt
    }
    decori {
      categoria
      decori {
        image {
          id
          url
        }
        id
        categoriaDecoro
        nomeWeb
        styleWidth
        styleHeight
      }
    }
    opuses {
      nome
      descrizione
      imageUrl
      imageAlt
      opusCodesPerFormati {
        codiceCatalogo
        numPezzi
        formato {
          id
          nome
          lato1Cm
          lato2Cm
          lato1Intero
          lato2Intero
          lato1Numeratore
          lato2Numeratore
          lato1Denominatore
          lato2Denominatore
          lato1PxWeb
          lato2PxWeb
        }
        articolo {
          id
          tonalita {
            nome
          }
          superficie {
            nome
          }
        }
      }
      opusCodesPerArticoli {
        codiceCatalogo
        numPezzi
        formato {
          id
          nome
          lato1Cm
          lato2Cm
          lato1Intero
          lato2Intero
          lato1Numeratore
          lato2Numeratore
          lato1Denominatore
          lato2Denominatore
          lato1PxWeb
          lato2PxWeb
        }
        articolo {
          id
          tonalita {
            nome
          }
          superficie {
            nome
          }
        }
      }
    }
    lappato
    lappatoUrl
    catalogo {
      nomeWeb
      url
    }
    cataloghiBrochure {
      nomeWeb
      url
    }
    certificazioni {
      pk
      title
      url
      logo
      ambientale
    }
    progetti {
      title
      destinazioneTitolo
      slug
      cittaId
      subtitle
      imageUrl
      imageAlt
      url
    }
    effetto {
      title
      imageUrl
    }
    magazines {
      title
      slug
      categoriaTitle
      description
      imageUrl
      url
    }
    categoriaEffetto {
      pk
      title
      abstract
      mainImage
      url
      slug
    }
    breadcrumbs {
      label
      url
    }
  }
}
    `;

/**
 * __useCollezioneQuery__
 *
 * To run a query within a React component, call `useCollezioneQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollezioneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollezioneQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      brand: // value for 'brand'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useCollezioneQuery(baseOptions: Apollo.QueryHookOptions<CollezioneQuery, CollezioneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollezioneQuery, CollezioneQueryVariables>(CollezioneDocument, options);
      }
export function useCollezioneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollezioneQuery, CollezioneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollezioneQuery, CollezioneQueryVariables>(CollezioneDocument, options);
        }
export type CollezioneQueryHookResult = ReturnType<typeof useCollezioneQuery>;
export type CollezioneLazyQueryHookResult = ReturnType<typeof useCollezioneLazyQuery>;
export type CollezioneQueryResult = Apollo.QueryResult<CollezioneQuery, CollezioneQueryVariables>;
export const MagazineDocument = gql`
    query Magazine($slug: String) {
  magazine(slug: $slug) {
    pk
    title
    pubDate
    imageUrl
    imageAlt
    descriptionHead
    descriptionFooter
    tag: categoriaTitle
    videoUrl
    premio
    magazineprogetti {
      id
      title
      url
    }
    magazinecollezioni {
      pk
      title
      url
      listingImage {
        url
        imageAlt
      }
      brand {
        pk
        logo
        logoTransparent
      }
    }
    correlati {
      pk
      title
      pubDate
      imageUrl
      imageAlt
      descriptionHead
      url
      tag: categoriaTitle
    }
    gallery {
      imageUrl
      imageAlt
    }
    model
  }
}
    `;

/**
 * __useMagazineQuery__
 *
 * To run a query within a React component, call `useMagazineQuery` and pass it any options that fit your needs.
 * When your component renders, `useMagazineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMagazineQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useMagazineQuery(baseOptions?: Apollo.QueryHookOptions<MagazineQuery, MagazineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MagazineQuery, MagazineQueryVariables>(MagazineDocument, options);
      }
export function useMagazineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MagazineQuery, MagazineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MagazineQuery, MagazineQueryVariables>(MagazineDocument, options);
        }
export type MagazineQueryHookResult = ReturnType<typeof useMagazineQuery>;
export type MagazineLazyQueryHookResult = ReturnType<typeof useMagazineLazyQuery>;
export type MagazineQueryResult = Apollo.QueryResult<MagazineQuery, MagazineQueryVariables>;
export const MagazineEvidenzaDocument = gql`
    query MagazineEvidenza {
  magazineEvidenza {
    pk
    title
    url
    imageUrl
    imageAlt
    subtitle
    description
    premio
    tag: categoriaTitle
  }
}
    `;

/**
 * __useMagazineEvidenzaQuery__
 *
 * To run a query within a React component, call `useMagazineEvidenzaQuery` and pass it any options that fit your needs.
 * When your component renders, `useMagazineEvidenzaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMagazineEvidenzaQuery({
 *   variables: {
 *   },
 * });
 */
export function useMagazineEvidenzaQuery(baseOptions?: Apollo.QueryHookOptions<MagazineEvidenzaQuery, MagazineEvidenzaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MagazineEvidenzaQuery, MagazineEvidenzaQueryVariables>(MagazineEvidenzaDocument, options);
      }
export function useMagazineEvidenzaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MagazineEvidenzaQuery, MagazineEvidenzaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MagazineEvidenzaQuery, MagazineEvidenzaQueryVariables>(MagazineEvidenzaDocument, options);
        }
export type MagazineEvidenzaQueryHookResult = ReturnType<typeof useMagazineEvidenzaQuery>;
export type MagazineEvidenzaLazyQueryHookResult = ReturnType<typeof useMagazineEvidenzaLazyQuery>;
export type MagazineEvidenzaQueryResult = Apollo.QueryResult<MagazineEvidenzaQuery, MagazineEvidenzaQueryVariables>;
export const AllMagazineDocument = gql`
    query AllMagazine {
  allMagazine {
    pk
    title
    slug
    url
    imageUrl
    imageAlt
    premio
    tag: categoriaTitle
  }
}
    `;

/**
 * __useAllMagazineQuery__
 *
 * To run a query within a React component, call `useAllMagazineQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMagazineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMagazineQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllMagazineQuery(baseOptions?: Apollo.QueryHookOptions<AllMagazineQuery, AllMagazineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllMagazineQuery, AllMagazineQueryVariables>(AllMagazineDocument, options);
      }
export function useAllMagazineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllMagazineQuery, AllMagazineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllMagazineQuery, AllMagazineQueryVariables>(AllMagazineDocument, options);
        }
export type AllMagazineQueryHookResult = ReturnType<typeof useAllMagazineQuery>;
export type AllMagazineLazyQueryHookResult = ReturnType<typeof useAllMagazineLazyQuery>;
export type AllMagazineQueryResult = Apollo.QueryResult<AllMagazineQuery, AllMagazineQueryVariables>;
export const MagazineHomepageDocument = gql`
    query MagazineHomepage {
  magazineHomepage {
    pk
    title
    url
    imageUrl
    imageAlt
    subtitle
    description
    premio
    tag: categoriaTitle
  }
}
    `;

/**
 * __useMagazineHomepageQuery__
 *
 * To run a query within a React component, call `useMagazineHomepageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMagazineHomepageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMagazineHomepageQuery({
 *   variables: {
 *   },
 * });
 */
export function useMagazineHomepageQuery(baseOptions?: Apollo.QueryHookOptions<MagazineHomepageQuery, MagazineHomepageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MagazineHomepageQuery, MagazineHomepageQueryVariables>(MagazineHomepageDocument, options);
      }
export function useMagazineHomepageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MagazineHomepageQuery, MagazineHomepageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MagazineHomepageQuery, MagazineHomepageQueryVariables>(MagazineHomepageDocument, options);
        }
export type MagazineHomepageQueryHookResult = ReturnType<typeof useMagazineHomepageQuery>;
export type MagazineHomepageLazyQueryHookResult = ReturnType<typeof useMagazineHomepageLazyQuery>;
export type MagazineHomepageQueryResult = Apollo.QueryResult<MagazineHomepageQuery, MagazineHomepageQueryVariables>;
export const AllCategorieMagazineDocument = gql`
    query AllCategorieMagazine {
  allCategorieMagazine {
    pk
    title
    slug
  }
}
    `;

/**
 * __useAllCategorieMagazineQuery__
 *
 * To run a query within a React component, call `useAllCategorieMagazineQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCategorieMagazineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCategorieMagazineQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCategorieMagazineQuery(baseOptions?: Apollo.QueryHookOptions<AllCategorieMagazineQuery, AllCategorieMagazineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCategorieMagazineQuery, AllCategorieMagazineQueryVariables>(AllCategorieMagazineDocument, options);
      }
export function useAllCategorieMagazineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCategorieMagazineQuery, AllCategorieMagazineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCategorieMagazineQuery, AllCategorieMagazineQueryVariables>(AllCategorieMagazineDocument, options);
        }
export type AllCategorieMagazineQueryHookResult = ReturnType<typeof useAllCategorieMagazineQuery>;
export type AllCategorieMagazineLazyQueryHookResult = ReturnType<typeof useAllCategorieMagazineLazyQuery>;
export type AllCategorieMagazineQueryResult = Apollo.QueryResult<AllCategorieMagazineQuery, AllCategorieMagazineQueryVariables>;
export const PaginaDocument = gql`
    query Pagina($chiave: String, $path: String, $contentTypeId: Int, $objectId: Int, $preview: Boolean, $withMenuChildren: Boolean) {
  pagina(
    chiave: $chiave
    path: $path
    contentTypeId: $contentTypeId
    objectId: $objectId
    preview: $preview
    withMenuChildren: $withMenuChildren
  ) {
    ...PaginaNodeFragment
  }
}
    ${PaginaNodeFragmentFragmentDoc}`;

/**
 * __usePaginaQuery__
 *
 * To run a query within a React component, call `usePaginaQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginaQuery({
 *   variables: {
 *      chiave: // value for 'chiave'
 *      path: // value for 'path'
 *      contentTypeId: // value for 'contentTypeId'
 *      objectId: // value for 'objectId'
 *      preview: // value for 'preview'
 *      withMenuChildren: // value for 'withMenuChildren'
 *   },
 * });
 */
export function usePaginaQuery(baseOptions?: Apollo.QueryHookOptions<PaginaQuery, PaginaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginaQuery, PaginaQueryVariables>(PaginaDocument, options);
      }
export function usePaginaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginaQuery, PaginaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginaQuery, PaginaQueryVariables>(PaginaDocument, options);
        }
export type PaginaQueryHookResult = ReturnType<typeof usePaginaQuery>;
export type PaginaLazyQueryHookResult = ReturnType<typeof usePaginaLazyQuery>;
export type PaginaQueryResult = Apollo.QueryResult<PaginaQuery, PaginaQueryVariables>;
export const PagineCatchAllDocument = gql`
    query PagineCatchAll {
  pagine(tipologia: PAGE) {
    edges {
      node {
        path
      }
    }
  }
}
    `;

/**
 * __usePagineCatchAllQuery__
 *
 * To run a query within a React component, call `usePagineCatchAllQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagineCatchAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagineCatchAllQuery({
 *   variables: {
 *   },
 * });
 */
export function usePagineCatchAllQuery(baseOptions?: Apollo.QueryHookOptions<PagineCatchAllQuery, PagineCatchAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagineCatchAllQuery, PagineCatchAllQueryVariables>(PagineCatchAllDocument, options);
      }
export function usePagineCatchAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagineCatchAllQuery, PagineCatchAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagineCatchAllQuery, PagineCatchAllQueryVariables>(PagineCatchAllDocument, options);
        }
export type PagineCatchAllQueryHookResult = ReturnType<typeof usePagineCatchAllQuery>;
export type PagineCatchAllLazyQueryHookResult = ReturnType<typeof usePagineCatchAllLazyQuery>;
export type PagineCatchAllQueryResult = Apollo.QueryResult<PagineCatchAllQuery, PagineCatchAllQueryVariables>;
export const ProgettoDocument = gql`
    query Progetto($slug: String) {
  progetto(slug: $slug) {
    pk
    slug
    modelPk
    title
    premio
    imageUrl
    description
    sottotitolo
    descriptionFooter
    destinazioni {
      id
      titolo
      slug
    }
    url
    imageAlt
    collezioni {
      id
      url
      nome
      listingImage {
        url
        imageAlt
      }
    }
    correlati {
      title
      premio
      destinazioni {
        id
        titolo
        slug
      }
      imageUrl
      url
    }
    infoProgettiCollezione {
      collezione {
        nome
        url
        slug
        brand {
          nome
          slug
        }
        categoriaEffetto {
          slug
        }
      }
      infoProgetti {
        id
        formato {
          nome
          lato1Cm
          lato2Cm
        }
        coloreNome
        finituraNome
        tonalitaUrl
        superficie {
          nome
        }
        spessore
      }
    }
    galleryProgettoDetail {
      id
      url
      imageAlt
    }
    breadcrumbs {
      label
      url
    }
  }
}
    `;

/**
 * __useProgettoQuery__
 *
 * To run a query within a React component, call `useProgettoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgettoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgettoQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useProgettoQuery(baseOptions?: Apollo.QueryHookOptions<ProgettoQuery, ProgettoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgettoQuery, ProgettoQueryVariables>(ProgettoDocument, options);
      }
export function useProgettoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgettoQuery, ProgettoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgettoQuery, ProgettoQueryVariables>(ProgettoDocument, options);
        }
export type ProgettoQueryHookResult = ReturnType<typeof useProgettoQuery>;
export type ProgettoLazyQueryHookResult = ReturnType<typeof useProgettoLazyQuery>;
export type ProgettoQueryResult = Apollo.QueryResult<ProgettoQuery, ProgettoQueryVariables>;
export const ProgettiDocument = gql`
    query Progetti {
  progetti {
    title
    premio
    imageAlt
    imageUrl
    description
    url
    slug
    tag: destinazioneTitolo
  }
}
    `;

/**
 * __useProgettiQuery__
 *
 * To run a query within a React component, call `useProgettiQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgettiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgettiQuery({
 *   variables: {
 *   },
 * });
 */
export function useProgettiQuery(baseOptions?: Apollo.QueryHookOptions<ProgettiQuery, ProgettiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgettiQuery, ProgettiQueryVariables>(ProgettiDocument, options);
      }
export function useProgettiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgettiQuery, ProgettiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgettiQuery, ProgettiQueryVariables>(ProgettiDocument, options);
        }
export type ProgettiQueryHookResult = ReturnType<typeof useProgettiQuery>;
export type ProgettiLazyQueryHookResult = ReturnType<typeof useProgettiLazyQuery>;
export type ProgettiQueryResult = Apollo.QueryResult<ProgettiQuery, ProgettiQueryVariables>;
export const ProgettiEvidenzaDocument = gql`
    query ProgettiEvidenza {
  progettiEvidenza {
    title
    premio
    imageUrl
    imageAlt
    description
    url
    tag: destinazioneTitolo
  }
}
    `;

/**
 * __useProgettiEvidenzaQuery__
 *
 * To run a query within a React component, call `useProgettiEvidenzaQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgettiEvidenzaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgettiEvidenzaQuery({
 *   variables: {
 *   },
 * });
 */
export function useProgettiEvidenzaQuery(baseOptions?: Apollo.QueryHookOptions<ProgettiEvidenzaQuery, ProgettiEvidenzaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgettiEvidenzaQuery, ProgettiEvidenzaQueryVariables>(ProgettiEvidenzaDocument, options);
      }
export function useProgettiEvidenzaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgettiEvidenzaQuery, ProgettiEvidenzaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgettiEvidenzaQuery, ProgettiEvidenzaQueryVariables>(ProgettiEvidenzaDocument, options);
        }
export type ProgettiEvidenzaQueryHookResult = ReturnType<typeof useProgettiEvidenzaQuery>;
export type ProgettiEvidenzaLazyQueryHookResult = ReturnType<typeof useProgettiEvidenzaLazyQuery>;
export type ProgettiEvidenzaQueryResult = Apollo.QueryResult<ProgettiEvidenzaQuery, ProgettiEvidenzaQueryVariables>;
export const CategorieProgettiDocument = gql`
    query CategorieProgetti {
  categorieProgetti {
    id
    title
  }
}
    `;

/**
 * __useCategorieProgettiQuery__
 *
 * To run a query within a React component, call `useCategorieProgettiQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorieProgettiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorieProgettiQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategorieProgettiQuery(baseOptions?: Apollo.QueryHookOptions<CategorieProgettiQuery, CategorieProgettiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategorieProgettiQuery, CategorieProgettiQueryVariables>(CategorieProgettiDocument, options);
      }
export function useCategorieProgettiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategorieProgettiQuery, CategorieProgettiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategorieProgettiQuery, CategorieProgettiQueryVariables>(CategorieProgettiDocument, options);
        }
export type CategorieProgettiQueryHookResult = ReturnType<typeof useCategorieProgettiQuery>;
export type CategorieProgettiLazyQueryHookResult = ReturnType<typeof useCategorieProgettiLazyQuery>;
export type CategorieProgettiQueryResult = Apollo.QueryResult<CategorieProgettiQuery, CategorieProgettiQueryVariables>;
export const RivenditoriDocument = gql`
    query Rivenditori($regione: String, $provincia: String, $citta: String) {
  rivenditori(regione: $regione, provincia: $provincia, citta: $citta) {
    pk
    nome
    latitudine: latitude
    longitudine: longitude
    telefono: telephone
    email
    mobile
    rivenditoreWeb
    promozionaleWeb
    citta
    cap
    indirizzo
    provincia
    regione
    nazione
    regioneSlug
    provinciaSlug
    cittaSlug
  }
}
    `;

/**
 * __useRivenditoriQuery__
 *
 * To run a query within a React component, call `useRivenditoriQuery` and pass it any options that fit your needs.
 * When your component renders, `useRivenditoriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRivenditoriQuery({
 *   variables: {
 *      regione: // value for 'regione'
 *      provincia: // value for 'provincia'
 *      citta: // value for 'citta'
 *   },
 * });
 */
export function useRivenditoriQuery(baseOptions?: Apollo.QueryHookOptions<RivenditoriQuery, RivenditoriQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RivenditoriQuery, RivenditoriQueryVariables>(RivenditoriDocument, options);
      }
export function useRivenditoriLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RivenditoriQuery, RivenditoriQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RivenditoriQuery, RivenditoriQueryVariables>(RivenditoriDocument, options);
        }
export type RivenditoriQueryHookResult = ReturnType<typeof useRivenditoriQuery>;
export type RivenditoriLazyQueryHookResult = ReturnType<typeof useRivenditoriLazyQuery>;
export type RivenditoriQueryResult = Apollo.QueryResult<RivenditoriQuery, RivenditoriQueryVariables>;
export const RegioniDocument = gql`
    query Regioni {
  regioni {
    pk
    name
    slug
    tipo
  }
}
    `;

/**
 * __useRegioniQuery__
 *
 * To run a query within a React component, call `useRegioniQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegioniQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegioniQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegioniQuery(baseOptions?: Apollo.QueryHookOptions<RegioniQuery, RegioniQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegioniQuery, RegioniQueryVariables>(RegioniDocument, options);
      }
export function useRegioniLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegioniQuery, RegioniQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegioniQuery, RegioniQueryVariables>(RegioniDocument, options);
        }
export type RegioniQueryHookResult = ReturnType<typeof useRegioniQuery>;
export type RegioniLazyQueryHookResult = ReturnType<typeof useRegioniLazyQuery>;
export type RegioniQueryResult = Apollo.QueryResult<RegioniQuery, RegioniQueryVariables>;
export const RegioneDocument = gql`
    query Regione($slug: String!) {
  regione(slug: $slug) {
    pk
    name
    slug
    tipo
  }
}
    `;

/**
 * __useRegioneQuery__
 *
 * To run a query within a React component, call `useRegioneQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegioneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegioneQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useRegioneQuery(baseOptions: Apollo.QueryHookOptions<RegioneQuery, RegioneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegioneQuery, RegioneQueryVariables>(RegioneDocument, options);
      }
export function useRegioneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegioneQuery, RegioneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegioneQuery, RegioneQueryVariables>(RegioneDocument, options);
        }
export type RegioneQueryHookResult = ReturnType<typeof useRegioneQuery>;
export type RegioneLazyQueryHookResult = ReturnType<typeof useRegioneLazyQuery>;
export type RegioneQueryResult = Apollo.QueryResult<RegioneQuery, RegioneQueryVariables>;
export const ProvinceDocument = gql`
    query Province($regione: String!) {
  province(regione: $regione) {
    pk
    name
    slug
    tipo
  }
}
    `;

/**
 * __useProvinceQuery__
 *
 * To run a query within a React component, call `useProvinceQuery` and pass it any options that fit your needs.
 * When your component renders, `useProvinceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProvinceQuery({
 *   variables: {
 *      regione: // value for 'regione'
 *   },
 * });
 */
export function useProvinceQuery(baseOptions: Apollo.QueryHookOptions<ProvinceQuery, ProvinceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProvinceQuery, ProvinceQueryVariables>(ProvinceDocument, options);
      }
export function useProvinceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProvinceQuery, ProvinceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProvinceQuery, ProvinceQueryVariables>(ProvinceDocument, options);
        }
export type ProvinceQueryHookResult = ReturnType<typeof useProvinceQuery>;
export type ProvinceLazyQueryHookResult = ReturnType<typeof useProvinceLazyQuery>;
export type ProvinceQueryResult = Apollo.QueryResult<ProvinceQuery, ProvinceQueryVariables>;
export const ProvinciaDocument = gql`
    query Provincia($slug: String!) {
  provincia(slug: $slug) {
    pk
    name
    slug
    tipo
    clienteRef {
      regioneDummy
      regioneSlug
    }
  }
}
    `;

/**
 * __useProvinciaQuery__
 *
 * To run a query within a React component, call `useProvinciaQuery` and pass it any options that fit your needs.
 * When your component renders, `useProvinciaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProvinciaQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useProvinciaQuery(baseOptions: Apollo.QueryHookOptions<ProvinciaQuery, ProvinciaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProvinciaQuery, ProvinciaQueryVariables>(ProvinciaDocument, options);
      }
export function useProvinciaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProvinciaQuery, ProvinciaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProvinciaQuery, ProvinciaQueryVariables>(ProvinciaDocument, options);
        }
export type ProvinciaQueryHookResult = ReturnType<typeof useProvinciaQuery>;
export type ProvinciaLazyQueryHookResult = ReturnType<typeof useProvinciaLazyQuery>;
export type ProvinciaQueryResult = Apollo.QueryResult<ProvinciaQuery, ProvinciaQueryVariables>;
export const CittaDocument = gql`
    query Citta($provincia: String!) {
  citta(provincia: $provincia) {
    pk
    name
    slug
    tipo
  }
}
    `;

/**
 * __useCittaQuery__
 *
 * To run a query within a React component, call `useCittaQuery` and pass it any options that fit your needs.
 * When your component renders, `useCittaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCittaQuery({
 *   variables: {
 *      provincia: // value for 'provincia'
 *   },
 * });
 */
export function useCittaQuery(baseOptions: Apollo.QueryHookOptions<CittaQuery, CittaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CittaQuery, CittaQueryVariables>(CittaDocument, options);
      }
export function useCittaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CittaQuery, CittaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CittaQuery, CittaQueryVariables>(CittaDocument, options);
        }
export type CittaQueryHookResult = ReturnType<typeof useCittaQuery>;
export type CittaLazyQueryHookResult = ReturnType<typeof useCittaLazyQuery>;
export type CittaQueryResult = Apollo.QueryResult<CittaQuery, CittaQueryVariables>;
export const CittaSingolareDocument = gql`
    query CittaSingolare($slug: String!) {
  cittaSingolare(slug: $slug) {
    pk
    name
    slug
    tipo
    clienteRef {
      regioneDummy
      regioneSlug
      provinciaDummy
      provinciaSlug
    }
  }
}
    `;

/**
 * __useCittaSingolareQuery__
 *
 * To run a query within a React component, call `useCittaSingolareQuery` and pass it any options that fit your needs.
 * When your component renders, `useCittaSingolareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCittaSingolareQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCittaSingolareQuery(baseOptions: Apollo.QueryHookOptions<CittaSingolareQuery, CittaSingolareQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CittaSingolareQuery, CittaSingolareQueryVariables>(CittaSingolareDocument, options);
      }
export function useCittaSingolareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CittaSingolareQuery, CittaSingolareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CittaSingolareQuery, CittaSingolareQueryVariables>(CittaSingolareDocument, options);
        }
export type CittaSingolareQueryHookResult = ReturnType<typeof useCittaSingolareQuery>;
export type CittaSingolareLazyQueryHookResult = ReturnType<typeof useCittaSingolareLazyQuery>;
export type CittaSingolareQueryResult = Apollo.QueryResult<CittaSingolareQuery, CittaSingolareQueryVariables>;
export const RivenditoreDocument = gql`
    query Rivenditore($id: String) {
  rivenditore(id: $id) {
    pk
    nome
    telefono: telephone
    email
    mobile
    indirizzo
    citta
    cap
    provincia
    regione
    nazione
  }
}
    `;

/**
 * __useRivenditoreQuery__
 *
 * To run a query within a React component, call `useRivenditoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useRivenditoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRivenditoreQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRivenditoreQuery(baseOptions?: Apollo.QueryHookOptions<RivenditoreQuery, RivenditoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RivenditoreQuery, RivenditoreQueryVariables>(RivenditoreDocument, options);
      }
export function useRivenditoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RivenditoreQuery, RivenditoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RivenditoreQuery, RivenditoreQueryVariables>(RivenditoreDocument, options);
        }
export type RivenditoreQueryHookResult = ReturnType<typeof useRivenditoreQuery>;
export type RivenditoreLazyQueryHookResult = ReturnType<typeof useRivenditoreLazyQuery>;
export type RivenditoreQueryResult = Apollo.QueryResult<RivenditoreQuery, RivenditoreQueryVariables>;
export const ProfessioniDocument = gql`
    query Professioni {
  professioni {
    title
    codice
  }
}
    `;

/**
 * __useProfessioniQuery__
 *
 * To run a query within a React component, call `useProfessioniQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfessioniQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfessioniQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfessioniQuery(baseOptions?: Apollo.QueryHookOptions<ProfessioniQuery, ProfessioniQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfessioniQuery, ProfessioniQueryVariables>(ProfessioniDocument, options);
      }
export function useProfessioniLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfessioniQuery, ProfessioniQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfessioniQuery, ProfessioniQueryVariables>(ProfessioniDocument, options);
        }
export type ProfessioniQueryHookResult = ReturnType<typeof useProfessioniQuery>;
export type ProfessioniLazyQueryHookResult = ReturnType<typeof useProfessioniLazyQuery>;
export type ProfessioniQueryResult = Apollo.QueryResult<ProfessioniQuery, ProfessioniQueryVariables>;
export const CreateContattoRivenditoreDocument = gql`
    mutation createContattoRivenditore($input: ContattoRivenditoreInput!) {
  createContattoRivenditore(input: $input) {
    status
  }
}
    `;
export type CreateContattoRivenditoreMutationFn = Apollo.MutationFunction<CreateContattoRivenditoreMutation, CreateContattoRivenditoreMutationVariables>;

/**
 * __useCreateContattoRivenditoreMutation__
 *
 * To run a mutation, you first call `useCreateContattoRivenditoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContattoRivenditoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContattoRivenditoreMutation, { data, loading, error }] = useCreateContattoRivenditoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContattoRivenditoreMutation(baseOptions?: Apollo.MutationHookOptions<CreateContattoRivenditoreMutation, CreateContattoRivenditoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContattoRivenditoreMutation, CreateContattoRivenditoreMutationVariables>(CreateContattoRivenditoreDocument, options);
      }
export type CreateContattoRivenditoreMutationHookResult = ReturnType<typeof useCreateContattoRivenditoreMutation>;
export type CreateContattoRivenditoreMutationResult = Apollo.MutationResult<CreateContattoRivenditoreMutation>;
export type CreateContattoRivenditoreMutationOptions = Apollo.BaseMutationOptions<CreateContattoRivenditoreMutation, CreateContattoRivenditoreMutationVariables>;
export const SoluzioneDocument = gql`
    query Soluzione($slug: String) {
  soluzione(slug: $slug) {
    pk
    title
    adminUrl
    visibile
    model
    modelClass
    pubblicato
    visibilitaDal
    visibilitaAl
    imageAlt
    image
    subtitle
    slug
    destinazioniUso {
      pk
      title
      image
    }
    correlati {
      pk
      title
      subtitle
      image
      imageAlt
      url
    }
    categorie {
      pk
      title
      url
      mainImage
    }
    pagina {
      ...SimplePaginaNodeFragment
    }
    pagebuilders {
      ...PagebuilderPlaceholderNodeFragment
    }
  }
}
    ${SimplePaginaNodeFragmentFragmentDoc}
${PagebuilderPlaceholderNodeFragmentFragmentDoc}`;

/**
 * __useSoluzioneQuery__
 *
 * To run a query within a React component, call `useSoluzioneQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoluzioneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoluzioneQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSoluzioneQuery(baseOptions?: Apollo.QueryHookOptions<SoluzioneQuery, SoluzioneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoluzioneQuery, SoluzioneQueryVariables>(SoluzioneDocument, options);
      }
export function useSoluzioneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoluzioneQuery, SoluzioneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoluzioneQuery, SoluzioneQueryVariables>(SoluzioneDocument, options);
        }
export type SoluzioneQueryHookResult = ReturnType<typeof useSoluzioneQuery>;
export type SoluzioneLazyQueryHookResult = ReturnType<typeof useSoluzioneLazyQuery>;
export type SoluzioneQueryResult = Apollo.QueryResult<SoluzioneQuery, SoluzioneQueryVariables>;
export const SoluzioniDocument = gql`
    query Soluzioni {
  soluzioni {
    pk
    url
    imageAlt
    slug
    title
    image
    url
  }
}
    `;

/**
 * __useSoluzioniQuery__
 *
 * To run a query within a React component, call `useSoluzioniQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoluzioniQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoluzioniQuery({
 *   variables: {
 *   },
 * });
 */
export function useSoluzioniQuery(baseOptions?: Apollo.QueryHookOptions<SoluzioniQuery, SoluzioniQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoluzioniQuery, SoluzioniQueryVariables>(SoluzioniDocument, options);
      }
export function useSoluzioniLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoluzioniQuery, SoluzioniQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoluzioniQuery, SoluzioniQueryVariables>(SoluzioniDocument, options);
        }
export type SoluzioniQueryHookResult = ReturnType<typeof useSoluzioniQuery>;
export type SoluzioniLazyQueryHookResult = ReturnType<typeof useSoluzioniLazyQuery>;
export type SoluzioniQueryResult = Apollo.QueryResult<SoluzioniQuery, SoluzioniQueryVariables>;
export const SostenibilitaCodiceEticoDocument = gql`
    query SostenibilitaCodiceEtico {
  sostenibilitaCodiceEtico {
    id
    nome
    url
    tipologie {
      nome
      codice
    }
    dataIns
    dataUltMod
  }
}
    `;

/**
 * __useSostenibilitaCodiceEticoQuery__
 *
 * To run a query within a React component, call `useSostenibilitaCodiceEticoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSostenibilitaCodiceEticoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSostenibilitaCodiceEticoQuery({
 *   variables: {
 *   },
 * });
 */
export function useSostenibilitaCodiceEticoQuery(baseOptions?: Apollo.QueryHookOptions<SostenibilitaCodiceEticoQuery, SostenibilitaCodiceEticoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SostenibilitaCodiceEticoQuery, SostenibilitaCodiceEticoQueryVariables>(SostenibilitaCodiceEticoDocument, options);
      }
export function useSostenibilitaCodiceEticoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SostenibilitaCodiceEticoQuery, SostenibilitaCodiceEticoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SostenibilitaCodiceEticoQuery, SostenibilitaCodiceEticoQueryVariables>(SostenibilitaCodiceEticoDocument, options);
        }
export type SostenibilitaCodiceEticoQueryHookResult = ReturnType<typeof useSostenibilitaCodiceEticoQuery>;
export type SostenibilitaCodiceEticoLazyQueryHookResult = ReturnType<typeof useSostenibilitaCodiceEticoLazyQuery>;
export type SostenibilitaCodiceEticoQueryResult = Apollo.QueryResult<SostenibilitaCodiceEticoQuery, SostenibilitaCodiceEticoQueryVariables>;
export const SostenibilitaPoliticaAziendaleDocument = gql`
    query SostenibilitaPoliticaAziendale {
  sostenibilitaPoliticaAziendale {
    id
    nome
    url
    tipologie {
      nome
      codice
    }
    dataIns
    dataUltMod
  }
}
    `;

/**
 * __useSostenibilitaPoliticaAziendaleQuery__
 *
 * To run a query within a React component, call `useSostenibilitaPoliticaAziendaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSostenibilitaPoliticaAziendaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSostenibilitaPoliticaAziendaleQuery({
 *   variables: {
 *   },
 * });
 */
export function useSostenibilitaPoliticaAziendaleQuery(baseOptions?: Apollo.QueryHookOptions<SostenibilitaPoliticaAziendaleQuery, SostenibilitaPoliticaAziendaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SostenibilitaPoliticaAziendaleQuery, SostenibilitaPoliticaAziendaleQueryVariables>(SostenibilitaPoliticaAziendaleDocument, options);
      }
export function useSostenibilitaPoliticaAziendaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SostenibilitaPoliticaAziendaleQuery, SostenibilitaPoliticaAziendaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SostenibilitaPoliticaAziendaleQuery, SostenibilitaPoliticaAziendaleQueryVariables>(SostenibilitaPoliticaAziendaleDocument, options);
        }
export type SostenibilitaPoliticaAziendaleQueryHookResult = ReturnType<typeof useSostenibilitaPoliticaAziendaleQuery>;
export type SostenibilitaPoliticaAziendaleLazyQueryHookResult = ReturnType<typeof useSostenibilitaPoliticaAziendaleLazyQuery>;
export type SostenibilitaPoliticaAziendaleQueryResult = Apollo.QueryResult<SostenibilitaPoliticaAziendaleQuery, SostenibilitaPoliticaAziendaleQueryVariables>;
export const TecnologiaDocument = gql`
    query Tecnologia($slug: String!) {
  tecnologia(slug: $slug) {
    pk
    adminUrl
    visibile
    model
    modelClass
    pubblicato
    visibilitaDal
    visibilitaAl
    subtitle
    title
    name
    imageAlt
    listingImage
    image
    correlati {
      pk
      title
      subtitle
      name
      listingImage
      url
      imageAlt
      image
    }
    pagina {
      ...SimplePaginaNodeFragment
    }
    pagebuilders {
      ...PagebuilderPlaceholderNodeFragment
    }
  }
}
    ${SimplePaginaNodeFragmentFragmentDoc}
${PagebuilderPlaceholderNodeFragmentFragmentDoc}`;

/**
 * __useTecnologiaQuery__
 *
 * To run a query within a React component, call `useTecnologiaQuery` and pass it any options that fit your needs.
 * When your component renders, `useTecnologiaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTecnologiaQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useTecnologiaQuery(baseOptions: Apollo.QueryHookOptions<TecnologiaQuery, TecnologiaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TecnologiaQuery, TecnologiaQueryVariables>(TecnologiaDocument, options);
      }
export function useTecnologiaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TecnologiaQuery, TecnologiaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TecnologiaQuery, TecnologiaQueryVariables>(TecnologiaDocument, options);
        }
export type TecnologiaQueryHookResult = ReturnType<typeof useTecnologiaQuery>;
export type TecnologiaLazyQueryHookResult = ReturnType<typeof useTecnologiaLazyQuery>;
export type TecnologiaQueryResult = Apollo.QueryResult<TecnologiaQuery, TecnologiaQueryVariables>;
export const TecnologieDocument = gql`
    query Tecnologie {
  tecnologie {
    pk
    subtitle
    title
    name
    listingImage
    url
    slug
    image
    imageAlt
  }
}
    `;

/**
 * __useTecnologieQuery__
 *
 * To run a query within a React component, call `useTecnologieQuery` and pass it any options that fit your needs.
 * When your component renders, `useTecnologieQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTecnologieQuery({
 *   variables: {
 *   },
 * });
 */
export function useTecnologieQuery(baseOptions?: Apollo.QueryHookOptions<TecnologieQuery, TecnologieQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TecnologieQuery, TecnologieQueryVariables>(TecnologieDocument, options);
      }
export function useTecnologieLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TecnologieQuery, TecnologieQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TecnologieQuery, TecnologieQueryVariables>(TecnologieDocument, options);
        }
export type TecnologieQueryHookResult = ReturnType<typeof useTecnologieQuery>;
export type TecnologieLazyQueryHookResult = ReturnType<typeof useTecnologieLazyQuery>;
export type TecnologieQueryResult = Apollo.QueryResult<TecnologieQuery, TecnologieQueryVariables>;
export const TonalitaDocument = gql`
    query Tonalita($brand: String!, $collezione: String!, $slug: String!, $preview: Boolean) {
  tonalita(brand: $brand, collezione: $collezione, slug: $slug, preview: $preview) {
    brand {
      id
      nome
      title
      slug
    }
    imageCollezione {
      id
      url
    }
    collezione {
      title
      sottotitolo
      slug
      url
      gallery {
        id
        url
      }
      shadeVariations {
        codice
        nome
        imageUrl
      }
      destinazioni {
        nome
        titolo
        imageUrl
      }
      shield
    }
    tonalitaCollezione {
      id
      pk
      modelPk
      tonalitaNome
      url
      articolo {
        image
      }
      breadcrumbs {
        label
        url
      }
      superficiSpessoriFormati {
        nome
        dcof
        bcra
        pendoloAS4586
        pendoloBS7976
        pendoloUNE41901
        scivolositaNome
        scivolositaLabel
        specificheAbcNome
        specificheAbcLabel
        spessori {
          spessore
          codice
          formati {
            nome
            lato1Intero
            lato2Intero
            lato1Numeratore
            lato2Numeratore
            lato1Denominatore
            lato2Denominatore
          }
        }
      }
      certificazioni {
        pk
        title
        url
        logo
        ambientale
      }
      gallery {
        id
        url
      }
    }
  }
}
    `;

/**
 * __useTonalitaQuery__
 *
 * To run a query within a React component, call `useTonalitaQuery` and pass it any options that fit your needs.
 * When your component renders, `useTonalitaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTonalitaQuery({
 *   variables: {
 *      brand: // value for 'brand'
 *      collezione: // value for 'collezione'
 *      slug: // value for 'slug'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useTonalitaQuery(baseOptions: Apollo.QueryHookOptions<TonalitaQuery, TonalitaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TonalitaQuery, TonalitaQueryVariables>(TonalitaDocument, options);
      }
export function useTonalitaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TonalitaQuery, TonalitaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TonalitaQuery, TonalitaQueryVariables>(TonalitaDocument, options);
        }
export type TonalitaQueryHookResult = ReturnType<typeof useTonalitaQuery>;
export type TonalitaLazyQueryHookResult = ReturnType<typeof useTonalitaLazyQuery>;
export type TonalitaQueryResult = Apollo.QueryResult<TonalitaQuery, TonalitaQueryVariables>;
export const AllTonalitaDocument = gql`
    query allTonalita {
  allTonalita {
    slug
    slugCollezione
    slugBrand
  }
}
    `;

/**
 * __useAllTonalitaQuery__
 *
 * To run a query within a React component, call `useAllTonalitaQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTonalitaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTonalitaQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllTonalitaQuery(baseOptions?: Apollo.QueryHookOptions<AllTonalitaQuery, AllTonalitaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTonalitaQuery, AllTonalitaQueryVariables>(AllTonalitaDocument, options);
      }
export function useAllTonalitaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTonalitaQuery, AllTonalitaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTonalitaQuery, AllTonalitaQueryVariables>(AllTonalitaDocument, options);
        }
export type AllTonalitaQueryHookResult = ReturnType<typeof useAllTonalitaQuery>;
export type AllTonalitaLazyQueryHookResult = ReturnType<typeof useAllTonalitaLazyQuery>;
export type AllTonalitaQueryResult = Apollo.QueryResult<AllTonalitaQuery, AllTonalitaQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    pk
    email
    nome
    cognome
    isStaff
    edit
    showToolbar
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Node": [
      "PaginaNode",
      "UtenteNode"
    ]
  }
};
      export default result;
    